import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Input } from '@progress/kendo-react-inputs';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { Popup, Offset, PopupOpenEvent } from '@progress/kendo-react-popup';
import { TreeList, TreeListColumnProps, TreeListRowProps, TreeListCellProps, TreeListHeaderCellProps, TreeListColumnResizeEvent } from "@progress/kendo-react-treelist";
import { mapStateToProps, mapDispatchToProps } from '../redux/reduxActions';
import {
    UserInfo, TcbObjInfo, SplSearchFilterResultItem, SplColDataDesc, TcbFileItem,
    TcbObjTreeItem, MenuItemModel, ClientQueryItem, TcbObjContextMenuItem, TcbObjTreeColItem, SplFetchQueueItem, SplFetchColDataResult
} from '../models/models';
import { addPageViewClass } from '../functions/generalFunctions'
import { downloadFileItem, downloadBlob, base64ToBlob } from '../functions/componentFunctions';
import { CustomWindow } from '../models/custom.window'
import { PageViewTypeEnum, SplColumnDataTypeEnum, TcbObjClassEnum, TcbFileLoadStatusEnum } from '../models/enums';
import { Menu, MenuSelectEvent } from "@progress/kendo-react-layout";
import moment from 'moment'

import './SplSearch.css';
import CheckBoxInputCtl from './InputCtls/CheckBoxInputCtl';


const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
declare let window: CustomWindow;

type SplSearchProps = PropsFromRedux & {
    menuItemId: number;
    stateToLoad?: SplSearchState;
    securityId: number;
    pageName: string;
    onOpenObjAction?: (e: TcbObjInfo) => void;
    onOpenImageAction?: (e: TcbObjInfo) => void;
    onOpenCqAction?: (securityId: number, cqId: number, tcbObjs: TcbObjInfo[]) => void;
    onOpenScanAction?: (tcbObjs: TcbObjInfo[]) => void;
    onSaveState?: (menuItemId: number, state: SplSearchState) => void;
    onSaveMenuItem?: (menuItemId: number, state: SplSearchState, menuCustomTxt: string) => void;
}

enum SearchResultsViewEnum {
    Blank,
    LoadingData,
    SearchComplete
}
enum ContextMenuStatus {
    LoadingMenu,
    Menu,
    CameraRunning,
    SavingPhoto,
    CancelPhoto,
    Closed
}



const filterByList = [
    { key: 'General', display: 'Search' },
    { key: 'Name', display: 'Filter by Name' },
    { key: 'Type', display: 'Filter by Type' },
]

interface SplSearchState {
    packlistTypeId: number;
    securityId: number;
    searchStr: string;
    searchResults: TcbObjTreeItem[];
    searchResultsFiltered: TcbObjTreeItem[];
    searchResultsStatus: SearchResultsViewEnum;
    selectedFilterBy: {};
    summaryResults: SplSearchFilterResultItem[];
    selectedSummaryResult?: SplSearchFilterResultItem;
    headerSelectVal: boolean;
    treeListStyle: React.CSSProperties;
    treeListTableStyle: React.CSSProperties;
    headerStyle: React.CSSProperties;
    treeListCols: TreeListColumnProps[];
    treeListColDataDesc: SplColDataDesc[];
    descColWidth: number;
    popupStatus: ContextMenuStatus;
    popupOpen: boolean;
    popupMenuDataDict: TcbObjContextMenuItem[];
    popupMenuData: MenuItemModel[];
    popupMenuDataMultiSelect: MenuItemModel[];
    popupMenuDataFetching: boolean;
    popupDataItems: TcbObjTreeItem[];
    popupMenuDataMultiSelectFetching: boolean;
    popupMenuDataMultiSelectFetched: boolean;
    fetchQueue: SplFetchQueueItem[];
    selectedItemId: string;
    scrollPosition: number;
    editingCell?: { rowId: string, colIndex: number } | null;
    editingValue?: string;
    savingCell?: { rowId: string, colIndex: number } | null;
    attachmentMenuOpen: string | null;  // Track which attachment menu is open (item ID)
    attachmentMenuAnchor: HTMLElement | null;  // Track the anchor element for popup
    expandAllInProgress: boolean;
    expandAllCancelRequested: boolean;
    idsOnly: boolean;
    // Full, unfiltered dataset from the last non-idsOnly search. idsOnly searches always
    // filter against this rather than the (possibly already-filtered) current searchResults.
    // Kept in state (rather than an instance field) so it's preserved via onSaveMenuItem /
    // stateToLoad when a new sidebar page is created for a search.
    fullSearchResults: TcbObjTreeItem[];
}

declare function invokeEnableZebraScannerAction(callBackFunc: string, callBackId: string): void;
declare function invokeDisableZebraScannerAction(): void;
declare function invokeOpenCameraAction(arg: any): any;
declare function invokeOpenCameraScannerAction(callBackFunc: string, callBackId: string): void;

class SplSearch extends React.Component<SplSearchProps, SplSearchState> {

    containerRef: React.RefObject<HTMLDivElement>;
    treeListScrollElement: HTMLDivElement | null = null;

    shouldResetScroll = true; // default is true

    constructor(props: SplSearchProps) {
        super(props);

        this.containerRef = React.createRef();

        //Camera function needs ref
        window.splSrchRef = this;

        if (this.props.stateToLoad) {
            this.state = {
                ...this.props.stateToLoad,
                popupOpen: false,
                popupStatus: ContextMenuStatus.Closed,
                popupDataItems: [],
                popupMenuDataDict: [],
                popupMenuData: [],
                popupMenuDataFetching: false,
                fetchQueue: [],
                popupMenuDataMultiSelect: [],
                popupMenuDataMultiSelectFetching: false,
                popupMenuDataMultiSelectFetched: false,
                attachmentMenuOpen: null,
                attachmentMenuAnchor: null,
                expandAllInProgress: false,
                expandAllCancelRequested: false
            };
            this._isReload = true;
        } else {

            this.state = {
                packlistTypeId: 0,
                securityId: 0,
                searchStr: '',
                searchResults: [],
                searchResultsFiltered: [],
                searchResultsStatus: SearchResultsViewEnum.Blank,
                selectedFilterBy: filterByList.find(x => x.key === 'General')!,
                summaryResults: [],
                headerSelectVal: false,
                treeListStyle: {},
                treeListTableStyle: {},
                headerStyle: {},
                treeListCols: [],
                treeListColDataDesc: [],
                descColWidth: 200,
                popupOpen: false,
                popupStatus: ContextMenuStatus.Closed,
                popupDataItems: [],
                popupMenuDataDict: [],
                popupMenuData: [],
                popupMenuDataFetching: false,
                fetchQueue: [],
                popupMenuDataMultiSelect: [],
                popupMenuDataMultiSelectFetching: false,
                popupMenuDataMultiSelectFetched: false,
                selectedItemId: '',
                scrollPosition: 0,
                editingCell: null,
                editingValue: '',
                savingCell: null,
                attachmentMenuOpen: null,
                attachmentMenuAnchor: null,
                expandAllInProgress: false,
                expandAllCancelRequested: false,
                idsOnly: false,
                fullSearchResults: [],
            };
            this._isReload = false;
        }
    }

    private _isReload: boolean = true;
    private _popupOffSet: Offset = { top: 0, left: 0 };
    private _popupBlurTimeoutRef: any;
    private _popupDivRef: any;
    private _mounted = false;
    private _inFlightColFetchKeys: Set<string> = new Set<string>();
    private _pendingColFetchItems: Map<string, SplFetchQueueItem> = new Map<string, SplFetchQueueItem>();
    private _isColFetchInProgress: boolean = false;
    private _colDataAbortController: AbortController | null = null;
    private _colFetchGeneration: number = 0;
    private _visibleFetchTimer: number | null = null;
    private _expandAllCancelRequested: boolean = false;

    componentDidMount() {
        this._mounted = true;

        //Treelist needs height set
        window.addEventListener("resize", this.updateDimensions);

        //Enable Scanner
        if (typeof invokeEnableZebraScannerAction !== 'undefined') {
            invokeEnableZebraScannerAction('window.splSrchRef.loadScanCode', this.props.menuItemId.toString());
        }

        // Find the scrollable element with class "splSearchTreeList" after mounting
        if (this.containerRef.current) {
            this.treeListScrollElement = this.containerRef.current.querySelector('.splSearchTreeList');
            if (this.treeListScrollElement) {
                this.treeListScrollElement.addEventListener('scroll', this.onTreeListScroll);
            }
        }

        if (this._isReload) {

            let tcols = this.buildTreeListCol(this.state.treeListColDataDesc);
            this.updateDimensions();
            this.setState({ treeListCols: tcols }, () => {
                this.fetchVisibleUnfetchedData();
            });
            //this.restoreScrollPosition();

        } else {
            this.fetchGridColumns(SearchResultsViewEnum.LoadingData, () => {
                let tcols = this.buildTreeListCol(this.state.treeListColDataDesc);
                this.updateDimensions();
                this.setState({ treeListCols: tcols }, () => {
                    this.runSplSearch();
                });
            });
        }
    }


    componentWillUnmount() {
        this._mounted = false;
        if (this._colDataAbortController) {
            this._colDataAbortController.abort();
            this._colDataAbortController = null;
        }
        this._inFlightColFetchKeys.clear();
        this._pendingColFetchItems.clear();
        this._isColFetchInProgress = false;
        if (this._visibleFetchTimer !== null) {
            window.clearTimeout(this._visibleFetchTimer);
            this._visibleFetchTimer = null;
        }
        if (this.treeListScrollElement) {
            this.treeListScrollElement.removeEventListener('scroll', this.onTreeListScroll);
        }
        if (typeof invokeDisableZebraScannerAction !== 'undefined') {
            invokeDisableZebraScannerAction();
        }
        window.removeEventListener("resize", this.updateDimensions);


    }

    componentDidUpdate(prevProps) {
        if (this.state.scrollPosition > 0) {
            this.restoreScrollPosition();

            if (this.shouldResetScroll) {
                this.setState({ scrollPosition: 0 });
            }

        }

    }

    updateDimensions = () => {
        let body = document.body;
        if (body) {
            let hs: React.CSSProperties = { ...this.state.headerStyle };
            let gs: React.CSSProperties = { ...this.state.treeListStyle };
            let ts: React.CSSProperties = { ...this.state.treeListTableStyle };
            gs.height = body.clientHeight - 120;
            if (this.props.pageInf.pageViewMode === PageViewTypeEnum.Browser) {
                gs.width = body.clientWidth - 250;
            } else {
                gs.width = body.clientWidth;
            }
            // gs.width = this.calcColWidthTotal() - 240;
            ts.width = this.calcColWidthTotal();
            if (this.props.pageInf.pageViewMode === PageViewTypeEnum.Mobile) {
                hs.width = body.clientWidth;
                // gs.width = body.clientWidth;
            }
            this.setState({
                headerStyle: hs,
                treeListStyle: gs,
                treeListTableStyle: ts
            });
        }
    }

    calcColWidthTotal = () => {
        let wt = 0;
        this.state.treeListColDataDesc.filter(x => x.visible).forEach(x => { wt += x.pixels });
        return wt;
    }

    searchCriteriaChange = (e: InputChangeEvent) => {
        this.setState({ searchStr: e.value });
    }

    searchBtnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (this.state.expandAllInProgress) {
            return;
        }

        if (this.state.searchStr.trim().length === 0 || this.state.searchStr.trim().length >= 3)
            this.runSplSearch();
    }

    cameraScanClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {

        if (process.env.REACT_APP_RunMode === "DEV") {
            this.loadScanCode('0', 'AS|922037|20261006121011|');
        } else {

            if (typeof invokeOpenCameraScannerAction !== 'undefined') {
                this.setState({ searchResultsStatus: SearchResultsViewEnum.LoadingData });
                invokeOpenCameraScannerAction('window.splSrchRef.loadScanCode', '');
            }
            else {
                alert('invokeOpenCameraScannerAction not defined');
            }
        }
    }

    searchTxtKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (this.state.expandAllInProgress) {
            return;
        }

        if (e.key === 'Enter') {
            if (this.state.searchStr.trim().length === 0 || this.state.searchStr.trim().length >= 3)
                this.runSplSearch();
        }
    }


    fetchGridColumns = (newStatus: SearchResultsViewEnum, callback?: () => void) => {
        this.setState({ searchResultsStatus: SearchResultsViewEnum.LoadingData, treeListCols: [] });

        let url = this.props.userInf.currProject.apiUrl + '/api/ui/GetTcbObjTreeListColumns';

        let body = {
            securityId: this.props.securityId
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(r => r.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                        let plt = res.retValInt;
                        let tcps: SplColDataDesc[] = [...res.results];
                        //This list includes hidden cols, so we can fetch the description column width
                        let descWth = 200;
                        if (this.props.pageInf.pageViewMode === PageViewTypeEnum.Browser && tcps.some(x => x.id === "description")) {
                            descWth = tcps.find(x => x.id === "description")!.pixels;
                        }

                        this.setState({
                            packlistTypeId: plt,
                            securityId: this.props.securityId,
                            treeListColDataDesc: tcps.filter(x => x.visible && x.id !== "description"),
                            descColWidth: descWth,
                            searchResultsStatus: newStatus
                        }, () => { if (callback) callback(); });
                        break;
                    case "UNAUTH":
                        let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        this.setState({ searchResultsStatus: SearchResultsViewEnum.Blank });
                        break;
                    default:
                        throw (res.callStatusMessage)
                }
            })
            .catch(err => {
                alert('fetchGridColumns' + err);
                this.setState({ searchResultsStatus: SearchResultsViewEnum.Blank });
            });
    }

    buildTreeListCol = (colData: SplColDataDesc[]) => {
        let tcols: TreeListColumnProps[] = [];

        tcols.push({ title: "", width: 27, field: "selected", cell: this.renderSelectCell, locked: true, resizable: false });
        tcols.push({ title: "Description", width: this.state.descColWidth, cell: this.renderDescriptionCell, locked: true });

        colData.sort((a, b) => a.columnOrder - b.columnOrder)
            .forEach(x => {
                if (x.visible) {
                    let tcol: TreeListColumnProps = {
                        title: x.value,
                        width: x.pixels,
                        // width: "200px",
                        // width: x.pixels.toString + "px",
                        cell: this.renderDataColCell,
                        expandable: false,
                        locked: false
                    };
                    if (x.columnDesc && x.columnDesc.length > 0)
                        tcol.title = x.columnDesc;
                    tcols.push(tcol);
                }
            });
        return tcols;
    }

    rebindTreeListCol = () => {
        let tcols = this.state.treeListCols;
        tcols.forEach(x => { x.cell = this.renderDataColCell });
        tcols[0].cell = this.renderSelectCell;
        tcols[1].cell = this.renderDescriptionCell;
        return tcols;
    }


    selectedFilterByChange = (e: DropDownListChangeEvent) => {
    }

    loadScanCode = (callBackId: string, scannedCode: string) => {
        if (scannedCode.length === 0) {
            alert('No scanned code received');
            this.setState({
                searchResultsStatus: SearchResultsViewEnum.SearchComplete,
            });
            return;
        }

        this.setState({ searchResultsStatus: SearchResultsViewEnum.LoadingData });

        //Check for std MMG codes
        let sdt = this.getTcbObjFromScanCode(scannedCode);

        if (!sdt.tcbObjClass || !sdt.tcbObjId) {
            //Search barcode table for match
            let url = this.props.userInf.currProject.apiUrl + '/api/search/SearchByBarcode';
            let body = {
                barcodeStr: scannedCode
            }

            fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
                .then(resp => resp.json())
                .then(res => {
                    switch (res.callStatus) {
                        //Search API uses callStatus to indicate of barcode found
                        case "OK":
                            let sdt: TcbObjInfo = res.result;
                            this.setState({ searchResultsStatus: SearchResultsViewEnum.SearchComplete });
                            if (this.props.onOpenObjAction)
                                this.props.onOpenObjAction(sdt);

                            break;


                        case "UNAUTH":
                            let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                            this.props.updateUserInfo(uInf);
                            break;

                        default:
                            //Couldn't find scan.... fall back to  text search
                            this.setState({
                                searchResultsStatus: SearchResultsViewEnum.LoadingData,
                                searchStr: scannedCode
                            }, () => this.runSplSearch());

                    }
                })
                .catch(err => {
                    alert('Error scanning barcode ' + err.toString());
                    this.setState({
                        searchResultsStatus: SearchResultsViewEnum.SearchComplete
                    });
                });

        } else {

            //Verify object exists and/or user can view
            let url = this.props.userInf.currProject.apiUrl + '/api/details/GetTcbObjInfo';

            let body = {
                tcbObjClass: sdt.tcbObjClass,
                tcbObjId: sdt.tcbObjId
            }

            fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
                .then(resp => resp.json())
                .then(res => {
                    switch (res.callStatus) {
                        case "OK":
                            let sdt: TcbObjInfo = res.result;
                            this.setState({ searchResultsStatus: SearchResultsViewEnum.SearchComplete });
                            if (this.props.onOpenObjAction)
                                this.props.onOpenObjAction(sdt);
                            break;
                        case "UNAUTH":
                            let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                            this.props.updateUserInfo(uInf);
                            this.setState({
                                searchResultsStatus: SearchResultsViewEnum.Blank,
                            });
                            break;

                        default:
                            //Couldn't find scan.... fall back to  text search
                            this.setState({
                                searchResultsStatus: SearchResultsViewEnum.LoadingData,
                                searchStr: scannedCode
                            }, () => this.runSplSearch());
                    }
                })
                .catch(err => {
                    alert('Error fetching info for ' + sdt.toString());
                    this.setState({
                        searchResultsStatus: SearchResultsViewEnum.Blank,
                    });
                });

        }
    }

    getTcbObjFromScanCode = (scannedCode: string) => {
        let sdt = new TcbObjInfo();

        if (scannedCode.startsWith('AS|') || scannedCode.startsWith('IT|')) {
            sdt.tcbObjClass = TcbObjClassEnum.Item;
        }
        if (scannedCode.startsWith('PL|')) {
            sdt.tcbObjClass = TcbObjClassEnum.PackList;
        }

        let id = parseInt(scannedCode.substring(3, scannedCode.indexOf('|', 3)));
        if (!isNaN(id))
            sdt.tcbObjId = id;
        return sdt;
    }




    runSplSearch = () => {

        // Advance generation so stale async callbacks from previous searches are ignored.
        this._colFetchGeneration++;

        // Cancel in-flight column data calls so stale results do not mutate new search state.
        if (this._colDataAbortController) {
            this._colDataAbortController.abort();
            this._colDataAbortController = null;
        }
        this._inFlightColFetchKeys.clear();
        this._pendingColFetchItems.clear();
        this._isColFetchInProgress = false;

        // Note: idsOnly searches filter against state.fullSearchResults (captured from the
        // last full search), not state.searchResults, so it's safe to clear the displayed
        // results here for every search while the request is in flight.
        this.setState({ searchResultsStatus: SearchResultsViewEnum.LoadingData, searchResults: [], summaryResults: [], fetchQueue: [] });

        let url = this.props.userInf.currProject.apiUrl + '/api/search/SplSearchByDesc';

        let body = {
            searchObjTypeId: this.state.packlistTypeId,
            searchTxt: this.state.searchStr,
            securityId: this.state.securityId,
            idsOnly: this.state.idsOnly
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(r => r.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                    case "COMPLETE":
                        // Compute this up front and include it in the same setState call as the
                        // results below, so the saved/reopened page state (via onSaveMenuItem)
                        // always reflects the idsOnly value that produced these results.
                        let newIdsOnly = res.callStatus === "COMPLETE";

                        if (this.state.idsOnly) {

                            // res.results is a stripped-down id-only list - always filter the
                            // original full dataset (not the possibly already-filtered
                            // searchResults currently on screen) so searches don't compound.
                            let idsOnlyResults: TcbObjTreeItem[] = res.results || [];
                            let matchedKeys = new Set<string>(idsOnlyResults.map(r => this.getIdsOnlyMatchKey(r.tcbObj)));

                            let filteredResults = this.filterTreeByMatchedKeys(this.state.fullSearchResults, matchedKeys);
                            this.clearHighlighted(filteredResults);
                            this.updateButtonStatus(filteredResults);  // Set which context buttons are enabled

                            let summF: SplSearchFilterResultItem[] = [];
                            if (this.state.searchStr && this.state.searchStr.length > 0)
                                summF = this.buildSearchResultSummary(filteredResults);

                            this.setState({ searchResults: filteredResults, summaryResults: summF, searchResultsStatus: SearchResultsViewEnum.SearchComplete, idsOnly: newIdsOnly }, () => {
                                if (this.state.searchStr && this.state.searchStr.length > 0) {
                                    if (this.props.onSaveMenuItem)
                                        this.props.onSaveMenuItem(this.props.menuItemId, this.state, this.state.searchStr);
                                } else if (this.props.onSaveState) {
                                    this.props.onSaveState(this.props.menuItemId, this.state);
                                }

                                if (this.state.searchResults) {
                                    this.fetchVisibleUnfetchedData();
                                }
                            });
                        }
                        else {

                            let sResults: TcbObjTreeItem[] = res.results;
                            this.clearHighlighted(sResults);
                            this.initialiseColData(sResults);   //Need to initialise coldata array before saving state!
                            this.updateButtonStatus(sResults);  // Set which context buttons are enabled

                            let summ: SplSearchFilterResultItem[] = [];
                            if (this.state.searchStr && this.state.searchStr.length > 0)
                                summ = this.buildSearchResultSummary(sResults);

                            // Keep a master copy of this full dataset in state (not just a local
                            // var) so later idsOnly searches always filter from here, not from a
                            // narrowed subset, and so it round-trips via onSaveMenuItem / stateToLoad.
                            this.setState({ searchResults: sResults, summaryResults: summ, searchResultsStatus: SearchResultsViewEnum.SearchComplete, idsOnly: newIdsOnly, fullSearchResults: sResults }, () => {
                                if (this.state.searchStr && this.state.searchStr.length > 0) {
                                    if (this.props.onSaveMenuItem)
                                        this.props.onSaveMenuItem(this.props.menuItemId, this.state, this.state.searchStr);
                                } else if (this.props.onSaveState) {
                                    this.props.onSaveState(this.props.menuItemId, this.state);
                                }

                                if (this.state.searchResults) {
                                    this.fetchVisibleUnfetchedData();
                                }

                            });
                        }

                        break;
                    case "UNAUTH":
                        let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        break;


                    default:
                        throw (res.callStatusMessage)

                }
            })
            .catch(err => {
                console.log('runSplSearch: ' + err);
            });
    }

    fetchSplChilds = (itm: TcbObjTreeItem) => {
        return new Promise<void>((resolve) => {
            //Set Fetching indicator true
            let sr = this.state.searchResults;
            let fetItm = this.findTreeItem(itm.id, sr);
            if (fetItm) {
                fetItm.childItmsFetching = true;
                this.setState({ searchResults: sr });
            }

            let url = this.props.userInf.currProject.apiUrl + '/api/search/SplFetchChildren';

            let grandParentItem = this.findTreeItem(itm.parentId, sr);

            let parentId = 0;

            if (grandParentItem) {
                parentId = grandParentItem.tcbObj.tcbObjId;
            }


            let body = {
                tcbObj: itm.tcbObj,
                treeId: itm.id,
                securityId: this.state.securityId,
                parentId: parentId
            }

            fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
                .then(r => r.json())
                .then(res => {
                    switch (res.callStatus) {
                        case "OK":
                            let currSr = this.state.searchResults;
                            if (res.results) {
                                let sResults: TcbObjTreeItem[] = res.results;
                                this.initialiseColData(sResults);

                                if (!itm.childItems) itm.childItems = [];
                                itm.childItems.push(...sResults);
                            }
                            itm.childItmsFetching = false;
                            itm.childItmsFetched = true;
                            this.updateButtonStatus(currSr);
                            this.setState({ searchResults: currSr }, () => {
                                if (this.props.onSaveState) {
                                    this.props.onSaveState(this.props.menuItemId, this.state);
                                }

                                // Only fetch data for visible children, not all fetched children.
                                // Viewport-based system will fetch rest as user scrolls.
                                this.checkForUnfetchedData();
                                resolve();

                            });
                            break;
                        case "UNAUTH":
                            let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                            this.props.updateUserInfo(uInf);
                            itm.childItmsFetching = false;
                            this.setState({ searchResults: this.state.searchResults }, () => resolve());
                            break;

                        default:
                            itm.childItmsFetching = false;
                            this.setState({ searchResults: this.state.searchResults }, () => resolve());
                            break;
                    }
                })
                .catch(err => {
                    alert('fetchSplChilds: ' + err);
                    let currSr = this.state.searchResults;
                    itm.childItmsFetching = false;
                    this.setState({ searchResults: currSr }, () => resolve());
                });
        });
    }

    checkForUnfetchedData = () => {
        let fqs = this.getVisibleUnfetchedCols();
        this.processFetchQueue(fqs);
    }

    onTreeListScroll = () => {
        if (this._visibleFetchTimer !== null) {
            window.clearTimeout(this._visibleFetchTimer);
        }

        // Small debounce to avoid flooding API while user is actively scrolling.
        this._visibleFetchTimer = window.setTimeout(() => {
            this._visibleFetchTimer = null;
            this.fetchVisibleUnfetchedData();
        }, 120);
    }

    fetchVisibleUnfetchedData = () => {
        const fqs = this.getVisibleUnfetchedCols();
        this.processFetchQueue(fqs);
    }

    getVisibleUnfetchedCols = () => {
        const visibleRows = this.getVisibleRows();
        const allDataColumnIndexes = this.getAllDataColumnIndexes();
        return this.buildFetchQueueForRows(visibleRows, allDataColumnIndexes);
    }

    getAllDataColumnIndexes = () => {
        const indexes: number[] = [];
        for (let i = 0; i < this.state.treeListColDataDesc.length; i++) {
            indexes.push(i);
        }
        return indexes;
    }

    getVisibleRows = () => {
        const flatRows = this.flattenVisibleRows(this.state.searchResults);
        if (flatRows.length === 0) {
            return [] as TcbObjTreeItem[];
        }

        const rowHeight = 22;
        const bufferRows = 12;
        const scrollTop = this.treeListScrollElement ? this.treeListScrollElement.scrollTop : 0;
        const viewportHeight = this.treeListScrollElement ? this.treeListScrollElement.clientHeight : (this.state.treeListStyle.height as number || 0);

        const startRow = Math.max(0, Math.floor(scrollTop / rowHeight) - bufferRows);
        const visibleCount = Math.ceil((viewportHeight || 0) / rowHeight) + (bufferRows * 2);
        const endRow = Math.min(flatRows.length, startRow + Math.max(visibleCount, 30));

        return flatRows.slice(startRow, endRow);
    }

    flattenVisibleRows = (rows: TcbObjTreeItem[]) => {
        const result: TcbObjTreeItem[] = [];
        rows.forEach((row) => {
            result.push(row);
            if (row.itemExpanded && row.childItems && row.childItems.length > 0) {
                result.push(...this.flattenVisibleRows(row.childItems));
            }
        });
        return result;
    }

    getVisibleDataColumnIndexes = () => {
        const colDescs = this.state.treeListColDataDesc;
        if (!colDescs || colDescs.length === 0) {
            return [] as number[];
        }

        const totalWidth = colDescs.reduce((sum, c) => sum + (c.pixels || 0), 0);
        if (totalWidth <= 0) {
            return colDescs.map((_, i) => i);
        }

        const lockedWidth = 27 + this.state.descColWidth;
        const viewportWidth = this.treeListScrollElement ? this.treeListScrollElement.clientWidth : (this.state.treeListStyle.width as number || 0);
        const dataViewportWidth = Math.max(150, viewportWidth - lockedWidth);
        const scrollLeft = this.treeListScrollElement ? this.treeListScrollElement.scrollLeft : 0;

        const startPx = Math.max(0, scrollLeft);
        const endPx = startPx + dataViewportWidth;

        let running = 0;
        let startIdx = 0;
        let endIdx = colDescs.length - 1;

        for (let i = 0; i < colDescs.length; i++) {
            const nextRunning = running + (colDescs[i].pixels || 0);
            if (nextRunning >= startPx) {
                startIdx = Math.max(0, i - 1);
                break;
            }
            running = nextRunning;
        }

        running = 0;
        for (let i = 0; i < colDescs.length; i++) {
            running += (colDescs[i].pixels || 0);
            if (running >= endPx) {
                endIdx = Math.min(colDescs.length - 1, i + 1);
                break;
            }
        }

        const indexes: number[] = [];
        for (let i = startIdx; i <= endIdx; i++) {
            indexes.push(i);
        }
        return indexes;
    }

    buildFetchQueueForRows = (rows: TcbObjTreeItem[], colIndexes: number[]) => {
        let fqs: SplFetchQueueItem[] = [];
        if (!rows || rows.length === 0 || !colIndexes || colIndexes.length === 0) {
            return fqs;
        }

        rows.forEach((row) => {
            colIndexes.forEach((i) => {
                const cdi = row.colData && row.colData.length > i ? row.colData[i] : null;
                const cdd = this.state.treeListColDataDesc.length > i ? this.state.treeListColDataDesc[i] : null;
                if (!cdi || !cdd || cdi.valueFetched) {
                    return;
                }

                let fqItm: SplFetchQueueItem = new SplFetchQueueItem();
                fqItm.tcbObj = row.tcbObj;
                fqItm.treeId = row.id;
                fqItm.colDataDesc = cdd;
                fqItm.colIndex = i;
                fqs.push(fqItm);
            });
        });

        return fqs;
    }


    buildSearchResultSummary = (sRes: TcbObjTreeItem[]) => {
        let summ: SplSearchFilterResultItem[] = [];

        sRes.forEach(x => {
            summ.push({ key: x.id, value: x.tcbObj.tcbObjDesc });
            summ.push(...this.buildSearchResultSummLoop(x, 1));
        });

        return summ;
    }

    buildSearchResultSummLoop = (res: TcbObjTreeItem, level: number) => {
        let summ: SplSearchFilterResultItem[] = [];

        let prefix = '';
        let i = level;
        while (i > 0) {
            prefix += '-';
            i--;
        }

        summ.push({ key: res.id, value: prefix + res.tcbObj.tcbObjDesc });
        if (res.childItems && res.childItems.length > 0) {
            res.childItems.forEach(x => {
                summ.push(...this.buildSearchResultSummLoop(x, level + 1));
            });
        }

        return summ;
    }


    initialiseColData = (rws: TcbObjTreeItem[]) => {
        if (rws) {
            rws.forEach(x => {
                x.colData = [];
                this.state.treeListColDataDesc.forEach((y, i) => {
                    var tci: TcbObjTreeColItem = new TcbObjTreeColItem();
                    tci.id = i;
                    tci.valueFetched = false;
                    x.colData.push(tci);
                });
                if (x.hasChildren) {
                    this.initialiseColData(x.childItems);
                }
            });
        }
    }

    processFetchQueue = (fq: SplFetchQueueItem[]) => {

        if (!this._mounted || fq.length === 0) return;

        let sr = this.state.searchResults;
        let hasLocalUpdates = false;
        let remoteItems: SplFetchQueueItem[] = [];

        fq.forEach((x) => {
            if (!x.colDataDesc) {
                return;
            }

            const isLocalBasic = x.colDataDesc.columnType.toLowerCase() === "basic"
                && (x.colDataDesc.id === "PLIQuantity" || x.colDataDesc.id === "unitOfMeasure");

            if (isLocalBasic) {
                let _ci = this.findTreeColItem(x.treeId, x.colIndex, sr);
                if (_ci && !_ci.valueFetched) {
                    hasLocalUpdates = true;
                }
                return;
            }

            const key = x.treeId + '_' + x.colIndex.toString();
            if (!this._inFlightColFetchKeys.has(key)) {
                remoteItems.push(x);
            }
        });

        const localBasicItems = fq.filter(x => x.colDataDesc
            && x.colDataDesc.columnType.toLowerCase() === "basic"
            && (x.colDataDesc.id === "PLIQuantity" || x.colDataDesc.id === "unitOfMeasure"));

        if (localBasicItems.length > 0) {
            this.populateBasicColumnValues(localBasicItems);
        }

        if (hasLocalUpdates && this._mounted) {
            this.setState({ searchResults: sr });
        }

        if (remoteItems.length === 0) {
            return;
        }

        if (this._isColFetchInProgress) {
            this.enqueuePendingColFetchItems(remoteItems);
            return;
        }

        remoteItems.forEach(x => {
            this._inFlightColFetchKeys.add(x.treeId + '_' + x.colIndex.toString());
        });

        this._isColFetchInProgress = true;
        this.fetchColQueueItems(remoteItems, 0, this._colFetchGeneration);

    }

    findAllUnFetchedCols = (tlist: TcbObjTreeItem[]) => {
        let cdds = this.state.treeListColDataDesc;
        let fqs: SplFetchQueueItem[] = [];
        if (tlist) {
            tlist.forEach(x => {
                x.colData.forEach((c, i) => {
                    if (!c.valueFetched) {
                        let fqItm: SplFetchQueueItem = new SplFetchQueueItem();
                        fqItm.tcbObj = x.tcbObj;
                        fqItm.treeId = x.id;
                        if (cdds[i]) {
                            fqItm.colDataDesc = cdds[i];
                        }
                        fqItm.colIndex = i;
                        fqs.push(fqItm);
                    }
                });

                if (x.itemExpanded && (x.childItmsFetching || x.childItmsFetched)) {
                    fqs.push(...this.findAllUnFetchedCols(x.childItems));
                }
            });
        }
        return fqs;

    }

    findTreeItem = (treeId: string, tlist: TcbObjTreeItem[]): TcbObjTreeItem | null => {
        if (!tlist) {
            return null;
        }
        let f1 = tlist.find(x => x.id === treeId);
        if (f1)
            return f1;
        else {
            if (tlist.length > 0) {
                for (let tItm of tlist) {
                    let fti = this.findTreeItem(treeId, tItm.childItems);
                    if (fti)
                        return fti;
                }
            }
        }
        return null;
    }

    findTreeColItem = (treeId: string, colIndex: number, tlist: TcbObjTreeItem[]) => {
        let _treeRow = this.findTreeItem(treeId, tlist);
        if (_treeRow) {
            let treeRow: TcbObjTreeItem = _treeRow;
            return treeRow.colData[colIndex];
        } else {
            return null;
        }
    }

    populateBasicColumnValues = (fqis: SplFetchQueueItem[]) => {
        if (fqis) {
            fqis.forEach(x => {

                let sr = this.state.searchResults;
                let _ci = this.findTreeColItem(x.treeId, x.colIndex, sr);
                if (_ci) {
                    let ci = _ci;

                    switch (x.colDataDesc.id) {
                        case "PLIQuantity":

                            ci.value = x.tcbObj.tcbObjQty;
                            ci.dataType = SplColumnDataTypeEnum.Number;
                            ci.valueFetched = true;
                            break;

                        case "unitOfMeasure":
                            ci.value = x.tcbObj.tcbObjUOM;
                            ci.dataType = SplColumnDataTypeEnum.String;
                            ci.valueFetched = true;
                            break;
                    }
                }


            })
        }
    }

    fetchColQueueItems = (fqis: SplFetchQueueItem[], batchsize: number, generation: number) => {

        if (generation !== this._colFetchGeneration) {
            return;
        }

        if (!this._mounted || fqis.length === 0) {
            this._isColFetchInProgress = false;
            return;
        }

        // Use the optimized API which accepts a scaled-down payload to reduce network overhead.
        let url = this.props.userInf.currProject.apiUrl + '/api/SearchOptimized/FetchSplColDataV2';

        // The API is designed to handle mixed descriptor types in a single request.
        // It internally filters items into categories (milestones, attributes, images, etc.).
        // We only split for size (3000 item limit), not by descriptor type.
        let safeBatchSize = batchsize > 0 ? batchsize : 3000;
        let nowItems: SplFetchQueueItem[] = fqis.length > safeBatchSize ? fqis.slice(0, safeBatchSize) : fqis;
        let nextItems: SplFetchQueueItem[] = fqis.length > safeBatchSize ? fqis.slice(safeBatchSize) : [];

        // Build payload for the optimized API (Columns array mapped below)

        // Map items into the server's minimal DTO: FetchSplColDataRequest
        const columnsPayload = nowItems.map(i => ({
            TreeId: i.treeId,
            ColIndex: i.colIndex,
            TcbObj: i.tcbObj ? {
                TcbObjClass: i.tcbObj.tcbObjClass,
                TcbObjId: i.tcbObj.tcbObjId,
                TcbObjGuidStr: i.tcbObj.tcbObjGuidStr
            } : null,
            ColDesc: i.colDataDesc ? {
                ColumnType: i.colDataDesc.columnType,
                Id: i.colDataDesc.id,
                Value: i.colDataDesc.value,
                DataType: i.colDataDesc.dataType,
                MetadataId: i.colDataDesc.metadataId,
                Visible: i.colDataDesc.visible
            } : null
        }));

        let body = {
            UserId: this.props.userInf.currProjectUserId,
            SecurityId: this.state.securityId,
            OffsetMinutes: this.props.userInf.currProject?.offsetMinutes || 0,
            Columns: columnsPayload
        }

        const requestAbortController = new AbortController();
        this._colDataAbortController = requestAbortController;

        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token },
            signal: requestAbortController.signal
        })
            .then(r => r.json())
            .then(res => {
                if (generation !== this._colFetchGeneration) {
                    nowItems.forEach(x => {
                        this._inFlightColFetchKeys.delete(x.treeId + '_' + x.colIndex.toString());
                    });
                    if (this._colDataAbortController === requestAbortController) {
                        this._colDataAbortController = null;
                    }
                    return;
                }

                switch (res.callStatus) {
                    case "OK":
                        if (res.results.length > 0) {
                            let sr = this.state.searchResults;
                            const treeItemIndex = new Map<string, TcbObjTreeItem>();
                            this.buildTreeItemIndex(sr, treeItemIndex);
                            let colData: SplFetchColDataResult[] = res.results;
                            const returnedKeys = new Set<string>();
                            colData.forEach(x => {
                                returnedKeys.add(x.treeId + '_' + x.colIndex.toString());
                                const trItem = treeItemIndex.get(x.treeId);
                                if (trItem && trItem.colData && trItem.colData.length > x.colIndex) {
                                    let ci = trItem.colData[x.colIndex];
                                    ci.isError = false;
                                    ci.dataType = x.dataType;
                                    ci.attributeClassDataType = x.attributeClassDataType;
                                    ci.bold = x.bold;
                                    switch (x.dataType) {
                                        case SplColumnDataTypeEnum.AccessDenied:
                                            ci.value = null;
                                            break;
                                        case SplColumnDataTypeEnum.Date:
                                            ci.value = x.dateVal;
                                            break;
                                        case SplColumnDataTypeEnum.Attachment:
                                            ci.value = x.boolVal;
                                            //Set value of TreeItem
                                            trItem.hasAttachments = ci.value;
                                            // Note: attachmentFiles now fetched on-demand via fetchAttachmentsForTreeItem()
                                            break;
                                        case SplColumnDataTypeEnum.Image:
                                            ci.value = x.boolVal;
                                            //Set value of TreeItem
                                            trItem.hasImages = ci.value;
                                            break;

                                        case SplColumnDataTypeEnum.String:
                                        case SplColumnDataTypeEnum.Number:
                                        default:
                                            ci.value = x.stringVal;
                                            break;
                                    }
                                    ci.valueFetched = true;
                                }
                            });

                            // Prevent infinite retry loops when API omits some requested cells.
                            nowItems.forEach((itm) => {
                                const k = itm.treeId + '_' + itm.colIndex.toString();
                                if (!returnedKeys.has(k)) {
                                    const trItem = treeItemIndex.get(itm.treeId);
                                    if (trItem && trItem.colData && trItem.colData.length > itm.colIndex) {
                                        const ci = trItem.colData[itm.colIndex];
                                        ci.valueFetched = true;
                                        if (typeof ci.isError !== 'boolean') {
                                            ci.isError = false;
                                        }
                                    }
                                }
                            });

                            if (this._mounted) {
                                this.setState({ searchResults: sr }, () => {
                                    if (nextItems.length > 0) {
                                        this.fetchColQueueItems(nextItems, batchsize, generation);
                                    } else {
                                        this._isColFetchInProgress = false;
                                        this.flushPendingColFetchItems();
                                    }
                                });
                            }
                        } else {
                            if (nextItems.length > 0) {
                                this.fetchColQueueItems(nextItems, batchsize, generation);
                            } else {
                                this._isColFetchInProgress = false;
                                this.flushPendingColFetchItems();
                            }
                        }
                        break;
                    case "UNAUTH":
                        let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        this._isColFetchInProgress = false;
                        this._pendingColFetchItems.clear();
                        break;

                    default:
                        this._isColFetchInProgress = false;
                        this.flushPendingColFetchItems();
                }

                nowItems.forEach(x => {
                    this._inFlightColFetchKeys.delete(x.treeId + '_' + x.colIndex.toString());
                });
                if (this._colDataAbortController === requestAbortController) {
                    this._colDataAbortController = null;
                }
            })
            .catch(err => {
                if (generation !== this._colFetchGeneration) {
                    nowItems.forEach(x => {
                        this._inFlightColFetchKeys.delete(x.treeId + '_' + x.colIndex.toString());
                    });
                    if (this._colDataAbortController === requestAbortController) {
                        this._colDataAbortController = null;
                    }
                    return;
                }

                nowItems.forEach(x => {
                    this._inFlightColFetchKeys.delete(x.treeId + '_' + x.colIndex.toString());
                });
                this._isColFetchInProgress = false;
                if (this._colDataAbortController === requestAbortController) {
                    this._colDataAbortController = null;
                }
                if (err && err.name === 'AbortError') {
                    return;
                }
                this.flushPendingColFetchItems();
                console.log('fetchColQueueItems: ' + err);
            });
    }

    enqueuePendingColFetchItems = (items: SplFetchQueueItem[]) => {
        items.forEach((itm) => {
            const key = itm.treeId + '_' + itm.colIndex.toString();
            this._pendingColFetchItems.set(key, itm);
        });
    }

    flushPendingColFetchItems = () => {
        if (this._isColFetchInProgress) {
            return;
        }

        if (this._pendingColFetchItems.size > 0) {
            const pendingItems = Array.from(this._pendingColFetchItems.values());
            this._pendingColFetchItems.clear();
            pendingItems.forEach(x => {
                this._inFlightColFetchKeys.add(x.treeId + '_' + x.colIndex.toString());
            });
            this._isColFetchInProgress = true;
            this.fetchColQueueItems(pendingItems, 0, this._colFetchGeneration);
            return;
        }

        this.checkForUnfetchedData();
    }

    buildTreeItemIndex = (items: TcbObjTreeItem[], index: Map<string, TcbObjTreeItem>) => {
        items.forEach((itm) => {
            index.set(itm.id, itm);
            if (itm.childItems && itm.childItems.length > 0) {
                this.buildTreeItemIndex(itm.childItems, index);
            }
        });
    }

    onAttachmentIconClick = (event: React.MouseEvent<HTMLSpanElement>, trItem: TcbObjTreeItem) => {
        // If data is already loaded, just open the menu immediately
        if (trItem.attachmentFiles && trItem.attachmentFiles.length > 0) {
            this.setState({
                attachmentMenuOpen: trItem.id,
                attachmentMenuAnchor: event.currentTarget as HTMLElement
            });
            return;
        }

        // If not loaded and not currently loading, start the fetch
        if (!trItem.attachmentDownloading) {
            this.fetchAttachmentsForTreeItem(trItem, event.currentTarget as HTMLElement);
        }
    }

    fetchAttachmentsForTreeItem = (trItem: TcbObjTreeItem, anchorElement?: HTMLElement) => {
        // Only fetch if we haven't already fetched or are currently fetching
        if ((trItem.attachmentFiles && trItem.attachmentFiles.length > 0) || trItem.attachmentDownloading) {
            return;
        }

        trItem.attachmentDownloading = true;
        // Force re-render by creating new reference to searchResults
        this.setState({ searchResults: [...this.state.searchResults] });

        const url = this.props.userInf.currProject.apiUrl + '/api/details/GetTcbObjAttachmentList';
        const body = trItem.tcbObj;

        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token }
        })
            .then(r => r.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                        trItem.attachmentFiles = res.results || [];
                        trItem.attachmentDownloading = false;
                        // Open the menu if we have an anchor element
                        this.setState({
                            searchResults: [...this.state.searchResults],
                            attachmentMenuOpen: anchorElement ? trItem.id : null,
                            attachmentMenuAnchor: anchorElement || null
                        });
                        break;
                    case "UNAUTH":
                        let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        trItem.attachmentDownloading = false;
                        this.setState({ searchResults: [...this.state.searchResults] });
                        break;
                    default:
                        trItem.attachmentDownloading = false;
                        this.setState({ searchResults: [...this.state.searchResults] });
                        console.log('fetchAttachmentsForTreeItem error: ' + res.callStatusMessage);
                }
            })
            .catch(err => {
                trItem.attachmentDownloading = false;
                this.setState({ searchResults: [...this.state.searchResults] });
                console.log('fetchAttachmentsForTreeItem: ' + err);
            });
    }

    expandChange = (itm: TcbObjTreeItem) => {

        this.saveScrollPosition(() => {

            let sr = this.state.searchResults;

            let expItm = this.findTreeItem(itm.id, sr);
            if (expItm) {
                expItm.itemExpanded = !expItm.itemExpanded;
                //These updated search results should force a re-render, but it doesn't!!... so manual call
                this.setState({ searchResults: sr });

                //Do we need to fetch any data?
                if (!expItm.childItmsFetched) {
                    this.fetchSplChilds(itm);
                }
                else {
                    this.checkForUnfetchedData();
                }

            }
        });
    }

    getExpandAllRootItems = (items: TcbObjTreeItem[]) => {
        const sr = this.state.searchResults;
        const canonical: TcbObjTreeItem[] = [];
        const selectedIds = new Set<string>();

        items.forEach((itm) => {
            const current = this.findTreeItem(itm.id, sr);
            if (current && !selectedIds.has(current.id)) {
                selectedIds.add(current.id);
                canonical.push(current);
            }
        });

        if (canonical.length <= 1) {
            return canonical;
        }

        const index = new Map<string, TcbObjTreeItem>();
        this.buildTreeItemIndex(sr, index);

        return canonical.filter((itm) => {
            let parentId = itm.parentId;
            while (parentId) {
                if (selectedIds.has(parentId)) {
                    return false;
                }
                const parent = index.get(parentId);
                if (!parent) {
                    break;
                }
                parentId = parent.parentId;
            }
            return true;
        });
    }

    expandAllChildrenRecursive = async (itm: TcbObjTreeItem, visited: Set<string>) => {
        if (this._expandAllCancelRequested) {
            return;
        }

        let sr = this.state.searchResults;
        let expItm = this.findTreeItem(itm.id, sr);
        if (!expItm || visited.has(expItm.id)) {
            return;
        }

        visited.add(expItm.id);

        if (expItm.hasChildren) {
            expItm.itemExpanded = true;
            this.setState({ searchResults: sr });

            if (!expItm.childItmsFetched && !expItm.childItmsFetching) {
                await this.fetchSplChilds(expItm);
                if (this._expandAllCancelRequested) {
                    return;
                }
            }
        }

        if (expItm.childItems && expItm.childItems.length > 0) {
            for (const child of expItm.childItems) {
                if (this._expandAllCancelRequested) {
                    return;
                }
                await this.expandAllChildrenRecursive(child, visited);
            }
        }
    }

    cancelExpandAll = () => {
        if (!this.state.expandAllInProgress) {
            return;
        }

        this._expandAllCancelRequested = true;
        this.setState({ expandAllCancelRequested: true });
    }

    selectedAllCellChanged = (selectVal: boolean) => {
        let srs = this.state.searchResults;

        if (!selectVal) {
            //Unselect everything, just in case
            this.updateSelectVals(selectVal, srs);
        } else {
            this.updateSelectVals(selectVal, srs);
        }

        this.updateButtonStatus(srs);

        this.setState({ headerSelectVal: selectVal, searchResults: srs });
    }

    selectedSummaryResultChange = (e: DropDownListChangeEvent) => {
        var gg = e.value.key;
        let sr = this.state.searchResults;
        let tiF = this.findTreeItem(gg, sr);
        if (tiF) {
            let ti: TcbObjTreeItem = tiF;
            this.clearHighlighted(sr);
            this.setAllContracted(sr);
            ti.itemHighlighted = true;
            this.setParentsExpanded(ti, sr)
            this.setState({ searchResults: sr }, () => this.checkForUnfetchedData());
        }
    }

    // Builds the key used to match a full-tree item against an idsOnly result item.
    // PackListItem (T) rows don't have a stable numeric id, so they're matched by guid instead.
    getIdsOnlyMatchKey = (tcbObj: TcbObjInfo): string => {
        return tcbObj.tcbObjClass === TcbObjClassEnum.PackListItem
            ? `${tcbObj.tcbObjClass}_${tcbObj.tcbObjGuidStr}`
            : `${tcbObj.tcbObjClass}_${tcbObj.tcbObjId}`;
    }

    // Recursively filters the full tree down to only the items matched by an idsOnly search,
    // keeping any ancestor whose descendants matched so the tree hierarchy stays intact.
    filterTreeByMatchedKeys = (items: TcbObjTreeItem[], matchedKeys: Set<string>): TcbObjTreeItem[] => {
        if (!items) return [];

        let result: TcbObjTreeItem[] = [];
        items.forEach(item => {
            let childMatches = this.filterTreeByMatchedKeys(item.childItems, matchedKeys);
            let isMatch = matchedKeys.has(this.getIdsOnlyMatchKey(item.tcbObj));
            if (isMatch || childMatches.length > 0) {
                result.push({ ...item, childItems: childMatches, itemExpanded: childMatches.length > 0 ? true : item.itemExpanded });
            }
        });

        return result;
    }

    clearHighlighted = (sr: TcbObjTreeItem[]) => {
        sr.forEach(x => {
            x.itemHighlighted = false;
            if (x.childItems && x.childItems.length > 0)
                this.clearHighlighted(x.childItems);
        });
    }

    setAllContracted = (sr: TcbObjTreeItem[]) => {
        sr.forEach(x => {
            x.itemExpanded = false;
            if (x.childItems && x.childItems.length > 0)
                this.setAllContracted(x.childItems);
        });
    }

    setParentsExpanded = (ti: TcbObjTreeItem, sr: TcbObjTreeItem[]) => {
        if (ti.parentId) {
            let piF = this.findTreeItem(ti.parentId, sr);
            if (piF) {
                let pi: TcbObjTreeItem = piF;
                pi.itemExpanded = true;
                if (pi.parentId) {
                    this.setParentsExpanded(pi, sr);
                }
            }
        }
    }


    updateSelectVals = (e: boolean, srs: TcbObjTreeItem[]) => {
        let updCount = 0;
        srs.forEach(x => {
            x.itemSelected = e;
            updCount++;
            if (x.hasChildren && x.itemExpanded)
                updCount += this.updateSelectVals(e, x.childItems);
        })
        return updCount;
    }

    getSelectedRows = (srs: TcbObjTreeItem[]) => {
        let selRows: TcbObjTreeItem[] = [];
        srs.forEach(x => {
            if (x.itemSelected)
                selRows.push(x);
            if (x.hasChildren && x.itemExpanded) {
                this.getSelectedRows(x.childItems).forEach(r => {
                    selRows.push(r);
                });
            }
        })
        return selRows;
    }

    getSelectedRowCount = (srs: TcbObjTreeItem[]) => {
        let selCount = 0;
        srs.forEach(x => {
            if (x.itemSelected)
                selCount++;
            if (x.hasChildren && x.itemExpanded)
                selCount += this.getSelectedRowCount(x.childItems);
        })
        return selCount;

    }

    updateButtonStatus = (srs: TcbObjTreeItem[]) => {

        let selCount = this.getSelectedRowCount(srs);

        if (selCount > 0) {
            // Disable every visible unselected button
            this.updateButtonStatusLoop(srs)
        } else {
            this.enableButtonStatusLoop(srs);
        }
    }

    enableButtonStatusLoop = (srs: TcbObjTreeItem[]) => {
        srs.forEach(x => {
            x.contextMenuEnabled = true;
            if (x.hasChildren)
                this.enableButtonStatusLoop(x.childItems);
        })
    }

    updateButtonStatusLoop = (srs: TcbObjTreeItem[]) => {
        srs.forEach(x => {
            x.contextMenuEnabled = x.itemSelected;
            if (x.hasChildren)
                this.updateButtonStatusLoop(x.childItems);
        })
    }


    selectedCellChange = (d: TcbObjTreeItem, val: boolean) => {
        let sr = this.state.searchResults;
        let di = this.findTreeItem(d.id, sr);
        // let di = sr.find(x => x.id == d.id);
        if (di) {
            di.itemSelected = val;
            this.updateButtonStatus(sr);
            this.setState({
                searchResults: sr,
                popupMenuData: [],
                popupMenuDataMultiSelect: [],
                popupMenuDataMultiSelectFetched: false,
            });
        }
    }


    getTreeListWidth = () => {
        let tw = 0;
        this.state.treeListCols.forEach(x => {
            let wd = x.width as number;
            tw += wd;
        });
        return tw;
    }
    onColumnResize = (event: TreeListColumnResizeEvent) => {

        if (event.end) {
            let colDescs = this.state.treeListColDataDesc;
            if (event.index >= 2) {
                colDescs[event.index - 2].pixels = event.newWidth;
            }

            // this.setState({ treeListCols: event.columns }, () => {
            this.setState({ treeListColDataDesc: colDescs }, () => {
                if (this.props.onSaveState) {
                    this.props.onSaveState(this.props.menuItemId, this.state);
                }
            });
        }
    };

    //#region Pop / Context Menu events
    popupOpen = (e: PopupOpenEvent) => {
        this._popupDivRef?.focus();
    }

    onFocusHandler = () => {
        clearTimeout(this._popupBlurTimeoutRef);
        this._popupBlurTimeoutRef = undefined;
    };

    onBlurTimeout = () => {
        this.setState({
            popupStatus: ContextMenuStatus.Closed,
            popupOpen: false,
            popupDataItems: [],
        });

        this._popupBlurTimeoutRef = undefined;
    };

    onBlurHandler = (event) => {
        clearTimeout(this._popupBlurTimeoutRef);
        this._popupBlurTimeoutRef = setTimeout(this.onBlurTimeout);
    };

    openContextMenuClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, dataItem: TcbObjTreeItem) => {

        this.saveScrollPosition(() => {

            this._popupOffSet = { left: e.clientX, top: e.clientY };

            let srs = this.state.searchResults;
            let selCount = this.getSelectedRowCount(srs);
            let mitms: TcbObjContextMenuItem | null | undefined = null;
            if (selCount <= 1) {
                //use dataitem, not selected
                const parentTreeItemForCheck = this.findTreeItem(dataItem.parentId, srs);
                const parentForCheck = parentTreeItemForCheck ? parentTreeItemForCheck.tcbObj : null;
                mitms = this.getContextMenuItemsForObj(dataItem.tcbObj, parentForCheck);
                let popupDataItems: TcbObjTreeItem[] = [];
                popupDataItems.push(dataItem);

                if (mitms == null) {
                    this.setState({
                        popupOpen: true,
                        popupStatus: ContextMenuStatus.LoadingMenu,
                        popupDataItems: popupDataItems,
                        popupMenuData: [],
                        popupMenuDataFetching: true
                    }, () => {
                        const parentTreeItem = this.findTreeItem(dataItem.parentId, srs);
                        const parentTcbObj = parentTreeItem ? parentTreeItem.tcbObj : null;
                        this.fetchContextMenuItemsForObjType(dataItem.tcbObj, parentTcbObj);
                    });
                } else {
                    this.setState({
                        popupOpen: true,
                        popupStatus: ContextMenuStatus.Menu,
                        popupDataItems: popupDataItems,
                        popupMenuData: mitms.menuItems,
                        popupMenuDataFetching: false
                    });
                }
            } else {
                //Multiselect
                let selItems = this.getSelectedRows(this.state.searchResults);
                // if (this.state.popupMenuDataMultiSelectFetched) {
                //     this.setState({
                //         popupStatus: ContextMenuStatus.Menu,
                //         popupOpen: true,
                //         popupDataItems: selItems,
                //     });
                // } else {
                this.setState({
                    popupStatus: ContextMenuStatus.LoadingMenu,
                    popupDataItems: selItems,
                    popupMenuData: [],
                    popupMenuDataFetching: true
                }, () => {
                    if (!this.state.popupMenuDataMultiSelectFetching) {


                        // const seen = new Set<string>();

                        // const result = selItems
                        // .map(item => {
                        //     const { tcbObjTypeId, tcbObjClass } = item.tcbObj;
                        //     return `${tcbObjTypeId}|${tcbObjClass}`;
                        // })
                        // .filter(pair => {
                        //     if (seen.has(pair)) return false;
                        //     seen.add(pair);
                        //     return true;
                        // })
                        // .join(',');




                        // let tmp = selItems.map(item => `${item.tcbObj.tcbObjId}|${item.tcbObj.tcbObjClass}`)

                        // let tcbObj=tmp.distinct().join(',');
                        // this.fetchContextMenuItemsForMultiSelect(tcbOjs)

                        // Build a deduplicated list of type|class pairs for all selected items
                        const pairs = selItems.map(item => `${item.tcbObj.tcbObjTypeId}|${item.tcbObj.tcbObjClass}|${this.findTreeItem(item.parentId, srs)?.tcbObj.tcbObjTypeId || ''}`);
                        const uniquePairs = Array.from(new Set(pairs));
                        const tcbObjsParam = uniquePairs.join(',');
                        this.fetchContextMenuItemsForMultiSelect(tcbObjsParam);
                    }
                });
                //}

            }
        });
    }

    fetchContextMenuItemsForMultiSelect = (tcbObjs: string) => {

        let url = this.props.userInf.currProject.apiUrl + '/api/search/FetchClientQueriesForSPLMultiSelect?securityId=' + this.props.securityId.toString() + '&tcbObjs=' + tcbObjs;
        fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(r => r.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                        let menuItms: MenuItemModel[] = [];
                        menuItms.push({ text: 'These actions will apply to ALL selected items', action: 'Message', cssClass: 'menuTitle', disabled: true, items: [] });
                        menuItms.push({ text: '', cssClass: 'k-separator', disabled: true, items: [] });

                        // menuItms.push({ text: 'Update Milestone', icon: "paper-plane", action: 'MilestoneScan', cssClass: 'menuItem', disabled: false, items: [] });
                        menuItms.push({ text: '', cssClass: 'k-separator', disabled: true, items: [] });

                        menuItms.push({ text: 'Expand All', icon: "expand", action: 'ExpandAll', cssClass: 'menuItem', disabled: false, items: [] });

                        if (res.results.length === 0) {
                            menuItms.push({ text: 'No ' + this.props.pageName + ' actions are available', action: 'Message', cssClass: 'menuMessage', disabled: true, items: [] });
                        } else {
                            let cqItms = res.results as ClientQueryItem[];
                            cqItms.sort((a, b) => {
                                if (a.sortOrder < b.sortOrder)
                                    return -1;
                                else if (a.sortOrder > b.sortOrder)
                                    return 1;
                                else
                                    return a.description.localeCompare(b.description);
                            });
                            cqItms.forEach((x: ClientQueryItem) => {
                                let newMdl: MenuItemModel = new MenuItemModel();
                                newMdl.text = x.description;
                                newMdl.action = 'ClientQuery';
                                newMdl.cssClass = 'menuItem';
                                newMdl.disabled = false;
                                newMdl.items = [];
                                newMdl.data = x.id;
                                menuItms.push(newMdl);
                            });
                        }


                        this.setState({
                            popupStatus: ContextMenuStatus.Menu,
                            popupMenuDataMultiSelect: menuItms,
                            popupMenuDataMultiSelectFetched: true,
                            popupMenuDataMultiSelectFetching: false
                        })


                        break;
                    case "UNAUTH":
                        let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        break;

                    default:
                        throw (res.callStatusMessage)

                }
            })
            .catch(err => {
                alert('fetchContextMenuItemsForMultiSelect : ' + err);
            });
    }


    getContextMenuItemsForObj = (obj: TcbObjInfo, parentItem?: TcbObjInfo | null) => {
        const parentTypeId = parentItem ? parentItem.tcbObjTypeId : 0;
        let mdd = this.state.popupMenuDataDict.find(x => x.tcbObjClass === obj.tcbObjClass && x.tcbObjTypeId === obj.tcbObjTypeId && x.parentTcbObjTypeId === parentTypeId);
        if (mdd) {
            let tmpMdd: TcbObjContextMenuItem = new TcbObjContextMenuItem();
            tmpMdd.menuItems.push(...mdd.menuItems);
            //Append object specific header
            tmpMdd.menuItems.unshift({ text: 'Actions for : ' + obj.tcbObjDesc, action: 'Message', cssClass: 'menuTitle', disabled: true, items: [] });
            return tmpMdd;
        }

        return null;
    }

    // Ensure popupMenuDataDict contains a single entry per (class,type,parentType)
    private buildPopupMenuDataDictWith = (item: TcbObjContextMenuItem): TcbObjContextMenuItem[] => {
        const dd = this.state.popupMenuDataDict ? [...this.state.popupMenuDataDict] : [];
        const idx = dd.findIndex(x => x.tcbObjClass === item.tcbObjClass && x.tcbObjTypeId === item.tcbObjTypeId && x.parentTcbObjTypeId === item.parentTcbObjTypeId);
        if (idx === -1) {
            dd.push(item);
        } else {
            // Replace existing entry with latest (keeps most recent menuItems)
            dd[idx] = item;
        }
        return dd;
    }

    fetchContextMenuItemsForObjType = (itm: TcbObjInfo, parentItem: TcbObjInfo | null) => {

        let url = "";

        if (itm.tcbObjId && itm.tcbObjTypeId > 0) {

            switch (itm.tcbObjClass) {
                case TcbObjClassEnum.PackList:
                    url = this.props.userInf.currProject.apiUrl + '/api/search/FetchClientQueriesForPacklistType?securityId=' + this.props.securityId.toString() + '&packlistTypeid=' + itm.tcbObjTypeId.toString();
                    break;

                case TcbObjClassEnum.Item:
                case TcbObjClassEnum.PackListItem:
                    url = this.props.userInf.currProject.apiUrl + '/api/search/FetchClientQueriesForItemType?securityId=' + this.props.securityId.toString() + '&itemTypeId=' + itm.tcbObjTypeId.toString() + '&parentPacklistTypeId=' + (parentItem ? parentItem.tcbObjTypeId.toString() : '');
                    break;
            }

            fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
                .then(r => r.json())
                .then(res => {
                    switch (res.callStatus) {
                        case "OK":
                            //Build new menu for this type
                            let ctxMenuItm: TcbObjContextMenuItem = new TcbObjContextMenuItem();
                            ctxMenuItm.tcbObjClass = itm.tcbObjClass;
                            ctxMenuItm.tcbObjTypeId = itm.tcbObjTypeId;
                            ctxMenuItm.parentTcbObjTypeId = parentItem ? parentItem.tcbObjTypeId : 0;

                            let menuItms: MenuItemModel[] = [];
                            // menuItms.push({ text: 'Actions for : ' + itm.tcbObjDesc, action: 'Message', cssClass: 'menuTitle', disabled: true, items: [] });
                            menuItms.push({ text: 'Show Details', icon: "aggregate-fields", action: 'ShowDetails', cssClass: 'menuItem', disabled: false, items: [] });
                            menuItms.push({ text: 'Expand All', icon: "expand", action: 'ExpandAll', cssClass: 'menuItem', disabled: false, items: [] });
                            // menuItms.push({ text: 'Update Milestone', icon: "paper-plane", action: 'MilestoneScan', cssClass: 'menuItem', disabled: false, items: [] });
                            menuItms.push({ text: 'Refresh', icon: "reload", action: 'Refresh', cssClass: 'menuItem', disabled: false, items: [] });
                            // menuItms.push({ text: 'Refresh', action: 'Refresh', cssClass: 'menuItem', disabled: false, items: [] });
                            menuItms.push({ text: '', cssClass: 'k-separator', disabled: true, items: [] });

                            if (res.results.length !== 0) {
                                let cqItms = res.results as ClientQueryItem[];
                                cqItms.sort((a, b) => {
                                    if (a.sortOrder < b.sortOrder)
                                        return -1;
                                    else if (a.sortOrder > b.sortOrder)
                                        return 1;
                                    else
                                        return a.description.localeCompare(b.description);
                                });
                                cqItms.forEach((x: ClientQueryItem) => {
                                    let newMdl: MenuItemModel = new MenuItemModel();
                                    if (x.id === -1) {
                                        if (this.props.pageInf.pageViewMode === PageViewTypeEnum.Mobile || this.props.pageInf.pageViewMode === PageViewTypeEnum.Tablet) {
                                            //Special code for Add Photo option
                                            newMdl.text = x.description;
                                            newMdl.icon = "camera";
                                            newMdl.action = 'Camera';
                                            newMdl.cssClass = 'menuItem';
                                            newMdl.disabled = false;
                                            newMdl.items = [];
                                            newMdl.data = x.id;
                                            menuItms.push(newMdl);
                                        }
                                    } else {
                                        newMdl.text = x.description;
                                        newMdl.icon = "circle";
                                        newMdl.action = 'ClientQuery';
                                        newMdl.cssClass = 'menuItem';
                                        newMdl.disabled = false;
                                        newMdl.items = [];
                                        newMdl.data = x.id;
                                        menuItms.push(newMdl);
                                    }
                                });
                            }


                            ctxMenuItm.menuItems = menuItms;
                            let dd = this.buildPopupMenuDataDictWith(ctxMenuItm);

                            //Create current menu as well
                            let tmpMim: MenuItemModel[] = [];
                            tmpMim.push(...ctxMenuItm.menuItems);
                            tmpMim.unshift({ text: 'Actions for : ' + itm.tcbObjDesc, action: 'Message', cssClass: 'menuTitle', disabled: true, items: [] });


                            this.setState({
                                popupStatus: ContextMenuStatus.Menu,
                                popupMenuData: tmpMim,
                                popupMenuDataDict: dd,
                                popupMenuDataFetching: false
                            })


                            break;
                        case "UNAUTH":
                            let uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                            this.props.updateUserInfo(uInf);
                            break;

                        default:
                            throw (res.callStatusMessage)

                    }
                })
                .catch(err => {
                    alert('fetchContextMenuItemsForObjType : ' + err);
                });
        }
        else {
            //unknown type - just provide basic refresh menu option
            let ctxMenuItm: TcbObjContextMenuItem = new TcbObjContextMenuItem();
            ctxMenuItm.tcbObjClass = itm.tcbObjClass;
            ctxMenuItm.tcbObjTypeId = itm.tcbObjTypeId;
            ctxMenuItm.parentTcbObjTypeId = parentItem ? parentItem.tcbObjTypeId : 0;

            let menuItms: MenuItemModel[] = [];
            //menuItms.push({ text: 'Refresh', icon: "reload", action: 'Refresh', cssClass: 'menuItem', disabled: false, items: [] });

            ctxMenuItm.menuItems = menuItms;
            let dd = this.buildPopupMenuDataDictWith(ctxMenuItm);

            //Create current menu as well
            let tmpMim: MenuItemModel[] = [];
            tmpMim.push(...ctxMenuItm.menuItems);
            tmpMim.unshift({ text: 'Actions for : ' + itm.tcbObjDesc, action: 'Message', cssClass: 'menuTitle', disabled: true, items: [] });


            this.setState({
                popupStatus: ContextMenuStatus.Menu,
                popupMenuData: tmpMim,
                popupMenuDataDict: dd,
                popupMenuDataFetching: false
            })
        }
    }


    contextMenuClick = (e: MenuSelectEvent) => {

        this.shouldResetScroll = false;
        this.saveScrollPosition(() => {
            let dataItm = e.item as MenuItemModel;
            let itms = this.state.popupDataItems;

            if (itms && itms.length > 0) {

                this.setState({ selectedItemId: itms[0].id }, () => {
                    if (this.props.onSaveState) {
                        this.props.onSaveState(this.props.menuItemId, this.state);
                    }
                });
            }


            switch (dataItm.action) {
                case "Camera":
                    this.setState({
                        popupOpen: true,
                        popupStatus: ContextMenuStatus.CameraRunning,
                        popupMenuData: [],
                        popupMenuDataFetching: false
                    }, () => {
                        this.openCamera();
                    });
                    break;
                case "ShowDetails":
                    this.setState({
                        popupOpen: false,
                        popupStatus: ContextMenuStatus.Closed,
                        popupDataItems: [],
                    }, () => {

                        if (this.props.onOpenObjAction && itms.length === 1) {
                            this.props.onOpenObjAction(itms[0].tcbObj);
                        }
                    });
                    break;
                case "ExpandAll":
                    if (this.state.expandAllInProgress) {
                        break;
                    }

                    this.setState({
                        popupOpen: false,
                        popupStatus: ContextMenuStatus.Closed,
                        popupDataItems: [],
                    }, async () => {
                        this._expandAllCancelRequested = false;
                        this.setState({ expandAllInProgress: true, expandAllCancelRequested: false });

                        if (!itms || itms.length === 0) {
                            this.setState({ expandAllInProgress: false, expandAllCancelRequested: false });
                            return;
                        }

                        try {
                            const roots = this.getExpandAllRootItems(itms);
                            const visited = new Set<string>();

                            for (const root of roots) {
                                if (this._expandAllCancelRequested) {
                                    break;
                                }

                                try {
                                    await this.expandAllChildrenRecursive(root, visited);
                                } catch (err) {
                                    console.log('ExpandAll error for node ' + root.id + ': ' + err);
                                }
                            }

                            this.setState({ searchResults: this.state.searchResults }, () => {
                                this.checkForUnfetchedData();
                                if (this.props.onSaveState) {
                                    this.props.onSaveState(this.props.menuItemId, this.state);
                                }
                            });
                        } finally {
                            this._expandAllCancelRequested = false;
                            this.setState({ expandAllInProgress: false, expandAllCancelRequested: false });
                        }
                    });
                    break;
                case "MilestoneScan":
                    this.setState({
                        popupOpen: false,
                        popupStatus: ContextMenuStatus.Closed,
                        popupDataItems: [],
                    }, () => {

                        if (this.props.onOpenScanAction) {

                            let tcbObjs: TcbObjInfo[] = [];

                            for (let obj of itms) {
                                tcbObjs.push(obj.tcbObj);
                            }

                            this.props.onOpenScanAction(tcbObjs);
                        }
                    });
                    break;
                case "Refresh":
                    this.setState({
                        popupOpen: false,
                        popupStatus: ContextMenuStatus.Closed,
                        popupDataItems: [],
                        editingCell: null,
                        editingValue: '',
                        savingCell: null
                    }, () => {
                        if (itms.length === 1) {
                            this.refreshNode(itms[0]);
                        }
                    });
                    break;
                case "ClientQuery":
                    this.setState({
                        popupOpen: false,
                        popupStatus: ContextMenuStatus.Closed,
                        popupDataItems: [],
                    }, () => {

                        if (this.props.onOpenCqAction && itms.length > 0) {
                            let cqId = dataItm.data;
                            let tcbObjs: TcbObjInfo[] = [];
                            itms.forEach(x => { tcbObjs.push(x.tcbObj); });

                            this.props.onOpenCqAction(this.state.securityId, cqId, tcbObjs);
                        }
                    });

                    // alert('Run CQ id ' + e.item['data'] + ' for ' + this.state.popupDataItem?.tcbObj.tcbObjDesc);
                    break;
            }
            // this.setState({
            //     popupOpen: false,
            //     popupDataItems: [],
            // });
        });
    }

    openCamera = () => {

        if (typeof invokeOpenCameraAction !== 'undefined') {
            invokeOpenCameraAction('window.splSrchRef.loadCameraImage');
        }
        else {
            if (process.env.REACT_APP_RunMode === "DEV") {
                this.loadCameraImage('', 'IMG_DevTesting.png', 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=');
            } else {
                this.setState({
                    popupOpen: false,
                    popupStatus: ContextMenuStatus.Closed,
                    popupDataItems: [],
                });
                alert('invokeOpenCameraAction not defined');
            }
        }

    }

    loadCameraImage = (callbackId: string, fileName: string, fileBase64: string) => {

        if (fileBase64.length === 0) {
            this.setState({
                popupOpen: false,
                popupStatus: ContextMenuStatus.Closed,
                popupDataItems: [],
                popupMenuDataFetching: false
            });
            return;
        } else {
            this.setState({
                popupStatus: ContextMenuStatus.SavingPhoto,
            });
        }

        let itms = this.state.popupDataItems;
        let itm = itms[0].tcbObj

        let last = fileName.lastIndexOf(".");
        let ext = "";
        if (last > 0) {
            ext = fileName.substring(last);
        }

        fileName = itm.tcbObjDesc + "-" + moment().format("YYYYMMDDHHmm") + ext;

        let docType = "Item Photo";
        if (itm.tcbObjClass === "P") {
            docType = "Packlist Photo"
        }

        // Convert base64 to Blob and upload via FormData to SaveFileForm
        try {
            const blob = base64ToBlob(fileBase64, 'image/jpeg');
            const form = new FormData();
            form.append('file', blob, fileName);
            form.append('documentDefaultType', docType);

            const saveUrl = this.props.userInf.currProject.apiUrl + '/api/file/SaveFileForm';

            fetch(saveUrl, { method: 'POST', body: form, headers: { 'Authorization': 'Bearer ' + this.props.userInf.token } })
                .then(resp => { if (!resp.ok) throw Error(resp.statusText); return resp.json(); })
                .then(res => {
                    if (res.callStatus !== 'OK') throw Error(res.callStatusMessage || 'Upload failed');
                    let fi: TcbFileItem = res.result;
                    fi.fileDataStr = fileBase64;
                    fi.fileLoadStatus = TcbFileLoadStatusEnum.OK;
                    fi.canEdit = true;
                    fi.canDelete = true;
                    fi.documentTypeDesc = docType;

                    // Link file
                    const linkUrl = this.props.userInf.currProject.apiUrl + '/api/details/LinkFileToTcbObj';
                    const tcbObjs: TcbObjInfo[] = [itm];
                    const linkBody = { fileId: fi.fileId, tcbObjs };
                    fetch(linkUrl, { method: 'POST', body: JSON.stringify(linkBody), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
                        .then(r => { if (!r.ok) throw Error(r.statusText); return r.json(); })
                        .then(rj => {
                            if (rj.callStatus !== 'OK') alert('Photo link error - ' + rj.callStatusMessage);
                            this.setState({ popupOpen: false, popupStatus: ContextMenuStatus.Closed, popupDataItems: [], popupMenuDataFetching: false });
                        })
                        .catch(err => {
                            alert('Photo link error - ' + err.toString());
                            this.setState({ popupOpen: false, popupStatus: ContextMenuStatus.Closed, popupDataItems: [], popupMenuDataFetching: false });
                        });
                })
                .catch((err: any) => {
                    alert('Error saving image - ' + err.toString());
                    this.setState({ popupOpen: false, popupStatus: ContextMenuStatus.Closed, popupDataItems: [], popupMenuDataFetching: false });
                });
        } catch (err: any) {
            alert('Error preparing image upload - ' + err.toString());
            this.setState({ popupOpen: false, popupStatus: ContextMenuStatus.Closed, popupDataItems: [], popupMenuDataFetching: false });
        }

    }

    descriptionClick = (itm: TcbObjTreeItem) => {

        this.saveScrollPosition();

        if (this.props.onOpenObjAction && itm.tcbObj) {
            this.setState({ selectedItemId: itm.id }, () => {
                if (this.props.onSaveState) {
                    this.props.onSaveState(this.props.menuItemId, this.state);
                }
                this.props.onOpenObjAction?.(itm.tcbObj); // Move this here
            });
        }
    }

    imageIconClick = (trItem: TcbObjTreeItem) => {
        if (this.props.onOpenImageAction && trItem.tcbObj) {
            this.setState({ selectedItemId: trItem.id }, () => {
                if (this.props.onSaveState) {
                    this.props.onSaveState(this.props.menuItemId, this.state);
                }
            });

            this.saveScrollPosition(() => {
                if (this.props.onOpenImageAction) {
                    this.props.onOpenImageAction(trItem.tcbObj);
                }

            });
        }
    }


    attachmentMenuClick = (m: MenuSelectEvent, trItem: TcbObjTreeItem) => {
        let mdl = m.item as MenuItemModel;

        if (mdl.action !== "download") return;

        this.setState({ selectedItemId: trItem.id }, () => {
            if (this.props.onSaveState) {
                this.props.onSaveState(this.props.menuItemId, this.state);
            }
        });

        let trItm = this.findTreeItem(trItem.id, this.state.searchResults);
        if (trItm) {
            // mark as downloading and reset progress to avoid showing stale 100% from prior downloads
            trItm.attachmentDownloading = true;
            trItm.attachmentProgress = 0;
            this.setState({ searchResults: this.state.searchResults });
        }

        let url = this.props.userInf.currProject.apiUrl + '/api/file/GetTcbFileInfo';
        let body = {
            fileId: mdl.id,
            fetchFileData: false
        }

        fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(resp => resp.json())
            .then(res => {
                switch (res.callStatus) {
                    case "OK":
                        let fi = res.result as TcbFileItem;
                        // Start download and only clear spinner when download completes
                        this.downloadFileBytes(fi)
                            .finally(() => {
                                let trItm = this.findTreeItem(trItem.id, this.state.searchResults);
                                if (trItm) {
                                    trItm.attachmentDownloading = false;
                                    this.setState({ searchResults: this.state.searchResults });
                                }
                            });
                        break;

                    default:
                        alert(res.callStatusMessage);
                        // clear spinner for failure to get file info
                        let trItmFail = this.findTreeItem(trItem.id, this.state.searchResults);
                        if (trItmFail) {
                            trItmFail.attachmentDownloading = false;
                            this.setState({ searchResults: this.state.searchResults });
                        }
                }
            })
            .catch(err => {
                alert(err);
                let trItm = this.findTreeItem(trItem.id, this.state.searchResults);
                if (trItm) {
                    trItm.attachmentDownloading = false;
                    this.setState({ searchResults: this.state.searchResults });
                }
            });
    }

    // Fetch bytes for a file and trigger download. Streams when possible and reports progress by
    // updating trItem.attachmentProgress (0-100). Returns a Promise that resolves when download finished.
    downloadFileBytes = (f: TcbFileItem) => {
        const url = this.props.userInf.currProject.apiUrl + '/api/file/GetTcbFileBytes';
        const body = { fileId: f.fileId };

        return fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
            .then(async (resp) => {
                if (!resp.ok) {
                    const j = await resp.json().catch(() => null);
                    if (j && j.callStatus === 'UNAUTH') {
                        const uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                    }
                    throw new Error(resp.statusText || 'Download failed');
                }

                const contentType = resp.headers.get('Content-Type') || '';
                if (contentType.toLowerCase().includes('application/json')) {
                    const j = await resp.json();
                    if (j && j.callStatus === 'OK' && j.stringResponse) {
                        f.fileDataStr = j.stringResponse;
                        f.fileLoadStatus = TcbFileLoadStatusEnum.OK;
                        downloadFileItem(f);
                        return;
                    } else if (j && j.callStatus === 'UNAUTH') {
                        const uInf: UserInfo = { ...this.props.userInf, isAuthorised: false };
                        this.props.updateUserInfo(uInf);
                        return;
                    } else {
                        throw new Error(j && j.callStatusMessage ? j.callStatusMessage : 'Unknown server response');
                    }
                }

                // For binary responses, try streaming if available to report progress
                const cd = resp.headers.get('Content-Disposition');
                let fileName = f.fileName || 'download';
                if (cd) {
                    const match = /filename="?([^";]+)"?/.exec(cd);
                    if (match && match[1]) fileName = match[1];
                }

                const contentLengthHeader = resp.headers.get('Content-Length');
                const total = contentLengthHeader ? parseInt(contentLengthHeader, 10) : NaN;

                if (resp.body && resp.body.getReader) {
                    // stream and collect chunks
                    const reader = resp.body.getReader();
                    const chunks: Uint8Array[] = [];
                    let received = 0;

                    // find the trItem to update progress
                    const trItm = this.findTreeItemByFileId(f.fileId);
                    if (trItm) trItm.attachmentProgress = total ? 0 : -1; // -1 indeterminate

                    while (true) {
                        const { done, value } = await reader.read();
                        if (done) break;
                        if (value) {
                            chunks.push(value);
                            received += value.length;
                            if (total && trItm) {
                                trItm.attachmentProgress = Math.min(100, Math.round((received / total) * 100));
                                this.setState({ searchResults: this.state.searchResults });
                            }
                        }
                    }

                    // concatenate chunks into single Uint8Array
                    const totalLen = chunks.reduce((s, c) => s + c.length, 0);
                    const combined = new Uint8Array(totalLen);
                    let position = 0;
                    for (const chunk of chunks) {
                        combined.set(chunk, position);
                        position += chunk.length;
                    }
                    const blob = new Blob([combined], { type: resp.headers.get('Content-Type') || 'application/octet-stream' });
                    if (trItm) {
                        trItm.attachmentProgress = 100;
                        this.setState({ searchResults: this.state.searchResults });
                    }
                    f.fileLoadStatus = TcbFileLoadStatusEnum.OK;
                    downloadBlob(blob, fileName);
                    return;
                } else {
                    // fallback: read whole arrayBuffer
                    const arr = await resp.arrayBuffer();
                    const blob = new Blob([arr], { type: resp.headers.get('Content-Type') || 'application/octet-stream' });
                    f.fileLoadStatus = TcbFileLoadStatusEnum.OK;
                    const trItm = this.findTreeItemByFileId(f.fileId);
                    if (trItm) {
                        trItm.attachmentProgress = 100;
                        this.setState({ searchResults: this.state.searchResults });
                    }
                    downloadBlob(blob, fileName);
                    return;
                }
            })
            .catch(err => {
                f.fileLoadStatus = TcbFileLoadStatusEnum.Error;
                f.fileLoadErrorMsg = err.toString();
                const trItm = this.findTreeItemByFileId(f.fileId);
                if (trItm) {
                    trItm.attachmentProgress = 0;
                    this.setState({ searchResults: this.state.searchResults });
                }
                // Optionally show an alert
                alert('Download failed - ' + err.toString());
            });
    }

    // Helper: find the tree item that contains a file with given fileId
    findTreeItemByFileId(fileId: string): TcbObjTreeItem | null {
        const sr = this.state.searchResults;
        for (let item of sr) {
            const found = this.findTreeItemByFileIdLoop(item, fileId);
            if (found) return found;
        }
        return null;
    }

    private findTreeItemByFileIdLoop(item: TcbObjTreeItem, fileId: string): TcbObjTreeItem | null {
        if (item.attachmentFiles && item.attachmentFiles.some(x => x.fileId === fileId)) return item;
        if (item.childItems && item.childItems.length > 0) {
            for (let c of item.childItems) {
                const found = this.findTreeItemByFileIdLoop(c, fileId);
                if (found) return found;
            }
        }
        return null;
    }


    //#endregion Pop / Context Menu events

    refreshNode = (e: TcbObjTreeItem) => {

        e.colData.forEach((x) => {
            x.value = null;
            x.valueFetched = false;
        });
        let itms: TcbObjTreeItem[] = [];
        itms.push(e);
        let fq = this.findAllUnFetchedCols(itms)
        this.processFetchQueue(fq);

        if (e.hasChildren) {
            e.childItems = [];
            e.childItmsFetched = false;
            this.setState({ searchResults: this.state.searchResults }, () => {
                if (e.itemExpanded) this.fetchSplChilds(e);
            })
        }
    }

    saveScrollPosition = (callback?: () => void) => {

        if (this.treeListScrollElement) {
            const newScrollPosition = this.treeListScrollElement.scrollTop;
            this.setState({ scrollPosition: newScrollPosition }, () => {
                // Call the callback after the state update, if provided
                if (callback) callback();
            });
        }
    };

    restoreScrollPosition = () => {
        if (this.treeListScrollElement) {
            this.treeListScrollElement.scrollTop = this.state.scrollPosition;
        }
    };


    refreshGrid = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (this.state.expandAllInProgress) {
            return;
        }

        this.setState({
            popupOpen: false,
            popupStatus: ContextMenuStatus.Closed,
            popupDataItems: [],
            popupMenuDataDict: [],
            popupMenuDataFetching: false,
            fetchQueue: [],
            popupMenuDataMultiSelect: [],
            popupMenuDataMultiSelectFetching: false,
            popupMenuDataMultiSelectFetched: false,
            searchResultsStatus: SearchResultsViewEnum.LoadingData,
            idsOnly: false,
        }, () => {
            this.fetchGridColumns(SearchResultsViewEnum.LoadingData, () => {
                let tcols = this.buildTreeListCol(this.state.treeListColDataDesc);
                this.setState({ treeListCols: tcols }, () => {
                    this.runSplSearch();
                });
            });
        })
    }

    startEditCell = (rowId: string, colIndex: number, value: string) => {
        this.setState({ editingCell: { rowId, colIndex }, editingValue: value });
        const { searchResults } = this.state;
        const trItem = this.findTreeItem(rowId, searchResults); // Implement this lookup
        if (trItem) {
            const colItm = trItem.colData[colIndex];
            if (colItm && colItm.originalValue === undefined) {
                colItm.originalValue = colItm.value;
                colItm.isError = false;
            }
        }
        this.setState({
            editingCell: { rowId, colIndex },
            editingValue: value
        });
    };

    handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ editingValue: e.target.value });
    };

    saveEditCell = () => {
        const { editingCell, editingValue, searchResults } = this.state;
        if (!editingCell) return;
        const { rowId, colIndex } = editingCell;
        let row = this.findTreeItem(rowId, searchResults);
        if (row) {
            const originalValue = row.colData[colIndex].value ?? "";
            const newValue = editingValue ?? "";

            // Only proceed if the value actually changed
            if (originalValue === newValue) {
                // No change: just clear editing state, don't call API or show spinner
                this.setState({
                    editingCell: null,
                    editingValue: undefined,
                    savingCell: null
                });
                return;
            }

            // Value changed: update and save
            row.colData[colIndex].value = newValue;
            row.colData[colIndex].valueFetched = true;
            this.setState({
                searchResults,
                editingCell: null,
                editingValue: undefined,
                savingCell: { rowId, colIndex }
            }, () => {
                if (row) {
                    this.saveData(row, colIndex);
                }
            });
        } else {
            // If row not found, just clear editing state
            this.setState({ editingCell: null, editingValue: undefined });
        }
    };

    cancelEditCell = () => {

        const { editingCell, searchResults } = this.state;
        if (!editingCell) return;
        const { rowId, colIndex } = editingCell;
        let row = this.findTreeItem(rowId, searchResults);
        if (row) {
            row.colData[colIndex].value = row.colData[colIndex].originalValue ?? "";
            row.colData[colIndex].isError = false; // Reset error state
        }

        this.setState({ editingCell: null, editingValue: undefined });
    };



    saveData = (trItem: TcbObjTreeItem, inx: number) => {


        if (trItem) {
            let colItm = trItem.colData[inx];
            if (colItm && colItm.valueFetched) {
                let url = this.props.userInf.currProject.apiUrl + '/api/search/SaveTcbObjColData';
                let body = {
                    tcbObjId: trItem.tcbObj.tcbObjId,
                    tcbObjClass: trItem.tcbObj.tcbObjClass,
                    tcbObjTypeId: trItem.tcbObj.tcbObjTypeId,
                    columnType: this.state.treeListColDataDesc[inx].columnType,
                    columnId: this.state.treeListColDataDesc[inx].id,
                    value: colItm.value
                }

                fetch(url, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.props.userInf.token } })
                    .then(resp => resp.json())
                    .then(res => {
                        switch (res.callStatus) {
                            case "OK":
                                colItm.isError = false;
                                this.setState({ savingCell: null });
                                break;
                            case "FAIL":
                                // Revert value and set error
                                //if (colItm.originalValue !== undefined) {
                                //colItm.value = colItm.originalValue;
                                colItm.isError = true;
                                //}
                                this.setState({ savingCell: null });
                                break;
                            default:
                                alert(res.callStatusMessage);
                        }
                    })
                    .catch(err => {
                        alert(err);
                    });
            }
        }


    }


    renderSelectCell = (e: TreeListCellProps) => {
        let dataItm = e.dataItem as TcbObjTreeItem;
        if (dataItm && dataItm.tcbObj) {
            if (dataItm.childItmsFetching)
                return (<td className={'selectRowCell' + addPageViewClass(this.props.pageInf)}><span className="k-icon k-font-icon k-i-loading" /></td>);
            else
                return (<td className={'selectRowCell' + addPageViewClass(this.props.pageInf)}><CheckBoxInputCtl value={dataItm.itemSelected} onUpdate={(e) => { if (e != null) this.selectedCellChange(dataItm, e) }} /></td>);
        }
        else
            return (<td>sel</td>);
    }


    renderDescriptionCell = (e: TreeListCellProps) => {
        let dataItm = e.dataItem as TcbObjTreeItem;
        if (dataItm && dataItm.tcbObj) {
            return (<td className={'descriptionRowCell k-text-nowrap' + addPageViewClass(this.props.pageInf)}>
                {this.renderIndentSpans(e.level.length)}
                {this.renderExpanderSpan(dataItm)}
                {this.renderContextMenuButton(dataItm)}
                {this.renderIconCode(dataItm)}
                <span className='descSpan' onClick={() => this.descriptionClick(dataItm)} title={dataItm.tcbObj.tcbObjDesc}>{dataItm.tcbObj.tcbObjDesc}</span>
            </td>);
        }
        else
            return (<td>desc</td>);
    }

    renderIndentSpans = (e: number) => {
        let spns: JSX.Element[] = [];
        let i = 1;
        while (i < e) {
            spns.push(<span className={'indentSpan' + addPageViewClass(this.props.pageInf)} />)
            i++;
        }
        return spns;
    }

    renderExpanderSpan = (dataItm: TcbObjTreeItem) => {
        if (dataItm.hasChildren) {
            if (!dataItm.itemExpanded)
                return <span className={'k-icon k-font-icon k-i-expand expanderSpan' + addPageViewClass(this.props.pageInf)} onClick={() => this.expandChange(dataItm)} />;
            else
                return <span className={'k-icon k-font-icon k-i-collapse expanderSpan' + addPageViewClass(this.props.pageInf)} onClick={() => this.expandChange(dataItm)} />;
        } else {
            return <span className={'expanderSpan' + addPageViewClass(this.props.pageInf)} />;
        }
    }

    renderContextMenuButton = (dataItm: TcbObjTreeItem) => {
        return (<Button className={'contextBtn' + addPageViewClass(this.props.pageInf)} onClick={(e) => this.openContextMenuClick(e, dataItm)} disabled={!dataItm.contextMenuEnabled || this.state.expandAllInProgress} ><span className="k-icon k-font-icon k-i-more-vertical" /></Button>);
    }

    renderIconCode = (dataItm: TcbObjTreeItem) => {
        if (dataItm && dataItm.tcbObj && dataItm.tcbObj.tcbObjTypeIconCode) {
            const codeNum = Number(dataItm.tcbObj.tcbObjTypeIconCode);
            const iconCode = '&#' + codeNum.toString() + ';';
            const isKendoPrivateUse = codeNum >= 0xe000 && codeNum <= 0xf8ff;
            return (
                <span
                    className={(isKendoPrivateUse ? 'k-icon ' : '') + 'iconSpan' + addPageViewClass(this.props.pageInf)}
                    style={{ fontFamily: isKendoPrivateUse ? 'WebComponentsIcons' : 'inherit', lineHeight: 1 }}
                    dangerouslySetInnerHTML={{ __html: iconCode }}
                />
            )
        } else {
            return null;
        }
    }

    renderDataColCell = (e: TreeListCellProps) => {
        var colIdx = e.colIndex;
        let wdth = this.state.treeListCols[colIdx].width;
        let tdSt: React.CSSProperties = {};
        tdSt.width = wdth;

        let trItem = e.dataItem as TcbObjTreeItem;
        if (!trItem || !trItem.colData) {
            return (<td style={tdSt}>No Data</td>);
        }

        let colItm = trItem.colData[colIdx - 2];


        if (!colItm.valueFetched) {
            // return (<td className='DataFetching'></td>);
            return (<td style={tdSt} title='Data Loading...'><span className="k-icon k-font-icon k-i-loading" /></td>);
        } else {
            // helper to render value with bold when requested
            const renderCellValue = (val: any) => {
                if (colItm && colItm.bold) {
                    return (<strong>{val}</strong>);
                }
                return val;
            };
            const allowEdit = trItem.tcbObj.tcbObjClass === TcbObjClassEnum.PackListItem && this.props.pageName === "Project Costing"



            switch (colItm.dataType) {
                case SplColumnDataTypeEnum.NotApplicable:
                    return (<td style={tdSt} className="notApplicable" title='Not applicable'></td>);
                //return (<td style={tdSt} title='Not applicable'></td>);

                case SplColumnDataTypeEnum.AccessDenied:
                    return (<td style={tdSt} className="accessDenied" title='Access to data denied'></td>);
                //return (<td style={tdSt} title='Access to data denied'></td>);

                // case SplColumnDataTypeEnum.String:
                //     return (<td style={tdSt} className='colDataStr'>{colItm.value}</td>)
                case SplColumnDataTypeEnum.String: {

                    //TEST CODE - allow editing of attributes in Project Costing page
                    if (allowEdit) {

                        const { editingCell, editingValue } = this.state;
                        const isEditing = editingCell && editingCell.rowId === trItem.id && editingCell.colIndex === (colIdx - 2);

                        const { savingCell } = this.state;
                        const isSaving = savingCell && savingCell.rowId === trItem.id && savingCell.colIndex === (colIdx - 2);

                        let classBase = 'colDataStr';

                        if (colItm.isError) { classBase += ' input-error'; }


                        if (isEditing) {
                            return (
                                <td style={tdSt} className={classBase + ' editing'}>
                                    <input
                                        type="text"
                                        value={editingValue ?? ""}
                                        onChange={this.handleEditChange}
                                        onBlur={this.saveEditCell}
                                        onKeyDown={e => {
                                            if (e.key === "Enter") this.saveEditCell();
                                            if (e.key === "Escape") this.cancelEditCell();
                                        }}
                                        autoFocus
                                        style={{ width: "100%" }}
                                    />
                                </td>
                            );
                        }

                        if (isSaving) {
                            return (
                                <td style={tdSt} className={classBase + '  saving'}>
                                    <span className="k-icon k-font-icon k-i-loading" />
                                </td>
                            );
                        }
                        return (
                            <td
                                style={tdSt}
                                className={classBase}
                                onClick={() => this.startEditCell(trItem.id, colIdx - 2, colItm.value ?? "")}
                                title="Click to edit"
                            >
                                {colItm.value && colItm.value !== "" ? renderCellValue(colItm.value) : <span style={{ width: "100%" }}>&nbsp;</span>}
                            </td>
                        );
                    } else {

                        if (colItm.attributeClassDataType && colItm.attributeClassDataType.toLowerCase() === "hyperlink") {
                            if (colItm.value && (colItm.value.match(/^https?:\/\//i) || colItm.value.match(/^www\./i))) {
                                const fullUrl = colItm.value.startsWith('http') ? colItm.value : `https://${colItm.value}`;

                                return (
                                    <td style={tdSt}>
                                        <label
                                            onClick={() => window.open(fullUrl, '_blank', 'noopener,noreferrer')}
                                            title="Open link"
                                        >
                                            🔗
                                        </label>
                                    </td>
                                );
                            }
                        }
                        else {


                            return (
                                <td
                                    style={tdSt}
                                    className='colDataStr'
                                >
                                    {renderCellValue(colItm.value)}
                                </td>
                            );
                        }

                    }

                    return (<td style={tdSt}>&nbsp;</td>);

                }
                case SplColumnDataTypeEnum.Number:
                    return (<td style={tdSt} className='colDataNum'>{renderCellValue(colItm.value)}</td>)

                case SplColumnDataTypeEnum.Date:
                    let dt = colItm.value as Date;
                    let dateStr: string = moment(dt).format("DD-MMM-YY");
                    return (<td style={tdSt} className='colDataDate'>{renderCellValue(dateStr)}</td>);

                case SplColumnDataTypeEnum.DateTime:
                    let dt2 = colItm.value as Date;
                    let dateStr2: string = moment(dt2).format("DD-MMM-YY");
                    return (<td style={tdSt} className='colDataDate'>{renderCellValue(dateStr2)}</td>);

                case SplColumnDataTypeEnum.Attachment:

                    //tcbObj was updated when this column was fetched... contains file info we need.
                    if (trItem.attachmentDownloading || (typeof trItem.attachmentProgress === 'number' && trItem.attachmentProgress > 0 && trItem.attachmentProgress < 100)) {
                        // Show progress: indeterminate spinner if -1, else percent/progress bar
                        // Show spinner if progress is indeterminate (-1) or not a finite number yet
                        const prog = trItem.attachmentProgress;
                        if (prog === -1 || !isFinite(prog) || prog <= 0) {
                            return (<td style={tdSt} className='colDataAttach'><span className="k-icon k-font-icon k-i-loading" /></td>);
                        } else {
                            // show percent text and a small inline bar when we have a valid numeric progress
                            const pct = Math.min(100, Math.max(0, Math.round(prog)));
                            return (
                                <td style={tdSt} className='colDataAttach'>
                                    <div className="inlineProgress">
                                        <div className="inlineProgressBarOuter"><div className="inlineProgressBarInner" style={{ width: pct + '%' }} /></div>
                                        <div className="inlineProgressPct">{pct}%</div>
                                    </div>
                                </td>
                            );
                        }
                    } else if (trItem.hasAttachments) {
                        // Just show the paperclip icon with click handler
                        return (
                            <td style={tdSt} className='colDataAttach'>
                                <span
                                    className="k-icon k-font-icon k-i-clip-45"
                                    onClick={(e) => this.onAttachmentIconClick(e, trItem)}
                                    style={{ cursor: 'pointer' }}
                                />
                            </td>
                        );
                    } else {
                        return (<td style={tdSt} className='colDataAttach'></td>);
                    }
                case SplColumnDataTypeEnum.Image:

                    //tcbObj was updated when this column was fetched... contains file info we need.

                    if (trItem.hasImages) {

                        return (<td style={tdSt} className='colDataAttach'><span className="k-icon k-font-icon k-i-photo-camera" onClick={(e) => this.imageIconClick(trItem)} /></td>);
                    } else {
                        return (<td style={tdSt} className='colDataAttach'></td>);
                    }
                case SplColumnDataTypeEnum.NoData:
                    if (allowEdit) {
                        const { editingCell, editingValue } = this.state;
                        const isEditing = editingCell && editingCell.rowId === trItem.id && editingCell.colIndex === (colIdx - 2);

                        const { savingCell } = this.state;
                        const isSaving = savingCell && savingCell.rowId === trItem.id && savingCell.colIndex === (colIdx - 2);

                        if (isEditing) {
                            return (
                                <td style={tdSt} className='colDataStr editing'>
                                    <input
                                        type="text"
                                        value={editingValue ?? ""}
                                        onChange={this.handleEditChange}
                                        onBlur={this.saveEditCell}
                                        onKeyDown={e => {
                                            if (e.key === "Enter") this.saveEditCell();
                                            if (e.key === "Escape") this.cancelEditCell();
                                        }}
                                        autoFocus
                                        style={{ width: "100%" }}
                                    />
                                </td>
                            );
                        }

                        if (isSaving) {
                            return (
                                <td style={tdSt} className='colDataStr saving'>
                                    <span className="k-icon k-font-icon k-i-loading" />
                                </td>
                            );
                        }
                        return (
                            <td
                                style={tdSt}
                                className='colDataStr noData'
                                onClick={() => this.startEditCell(trItem.id, colIdx - 2, colItm.value ?? "")}
                                title="Click to edit"
                            >
                                {colItm.value && colItm.value !== "" ? colItm.value : <span style={{ width: "100%" }}>&nbsp;</span>}
                            </td>
                        );
                    }

                    return (<td style={tdSt} className='colDataStr noData'>&nbsp;</td>);
                default:
                    return (<td style={tdSt}>&nbsp;</td>);
            }
        }
    }



    renderNoRecords = () => {

        if (this.state.searchResultsStatus === SearchResultsViewEnum.LoadingData) {
            return (<div className="splLoadingIndicator"><span className="k-icon k-font-icon k-i-loading" /></div>);
        } else {
            return (<div>No Records</div>);
        }

    }

    renderHeaderCell = (defaultRendering: React.ReactNode, props: TreeListHeaderCellProps) => {
        switch (props.field) {
            case "selected":
                return <span title='Select All'><CheckBoxInputCtl value={this.state.headerSelectVal} onUpdate={(e) => { if (e != null) this.selectedAllCellChanged(e) }} /></span>
            default:
                return (<span title={props.title}>{props.title}</span>);
        }
    }

    renderRow = (rw: React.ReactElement<HTMLTableRowElement>, props: TreeListRowProps) => {

        const di = props.dataItem as TcbObjTreeItem;

        if (di.itemHighlighted) {
            return (<rw.type {...rw.props} className="highlightedRow" />);
        }

        if (di.isLinked) {
            return (<rw.type {...rw.props} className="linkedRow" />);
        }
        else {
            //return rw;
            return <rw.type {...rw.props} />;
        }

    }
    renderContextPopup = () => {

        let popupTitle = "";
        switch (this.state.popupStatus) {
            case ContextMenuStatus.CameraRunning:
                popupTitle = "Camera Running";
                break;
            case ContextMenuStatus.CancelPhoto:
                popupTitle = "Cancelling";
                break;
            case ContextMenuStatus.LoadingMenu:
                popupTitle = "Loading Menu";
                break;
            case ContextMenuStatus.SavingPhoto:
                popupTitle = "Saving Photo";
                break;
            case ContextMenuStatus.Menu:

                break;
        }

        switch (this.state.popupStatus) {
            case ContextMenuStatus.Menu:
                let selCount = this.getSelectedRowCount(this.state.searchResults);
                if (selCount <= 1) {
                    return (<Menu className="cellMenu" items={this.state.popupMenuData} openOnClick={true} vertical={true}
                        onSelect={(e) => this.contextMenuClick(e)} />);
                } else {
                    return (<Menu className="cellMenu" items={this.state.popupMenuDataMultiSelect} openOnClick={true} vertical={true}
                        onSelect={(e) => this.contextMenuClick(e)} />);
                }
            default:
                return (<div id="splSearchPopupLoading" ><div id="splSearchPopupLoadingTitle">{popupTitle}</div><span className="k-icon k-font-icon k-i-loading" /></div>);
        }
    }

    renderAttachmentPopup = () => {
        // Find the tree item recursively
        const findItem = (items: TcbObjTreeItem[]): TcbObjTreeItem | undefined => {
            for (const item of items) {
                if (item.id === this.state.attachmentMenuOpen) return item;
                if (item.childItems && item.childItems.length > 0) {
                    const found = findItem(item.childItems);
                    if (found) return found;
                }
            }
            return undefined;
        };

        const trItem = findItem(this.state.searchResults);
        if (!trItem) {
            return null;
        }

        return (
            <Popup
                anchor={this.state.attachmentMenuAnchor}
                show={true}
                popupClass="k-menu-popup attachment-popup"
                anchorAlign={{ horizontal: 'left', vertical: 'bottom' }}
                popupAlign={{ horizontal: 'left', vertical: 'top' }}
            >
                <ul
                    className="k-menu k-menu-vertical"
                    ref={(el) => { if (el) el.focus(); }}
                    tabIndex={-1}
                    onBlur={(e) => {
                        // Close if focus moved outside the popup
                        if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                            setTimeout(() => this.setState({ attachmentMenuOpen: null, attachmentMenuAnchor: null }), 200);
                        }
                    }}
                >
                    {trItem.attachmentDownloading || !trItem.attachmentFiles || trItem.attachmentFiles.length === 0 ? (
                        <li className="k-item menuMessage">
                            <span className="k-menu-link">
                                <span className="k-icon k-i-loading" /> Loading attachments...
                            </span>
                        </li>
                    ) : (
                        <>
                            <li className="k-item menuTitle">
                                <span className="k-menu-link">Attachments</span>
                            </li>
                            {trItem.attachmentFiles.map(file => (
                                <li
                                    key={file.fileId}
                                    className="k-item menuItem"
                                    onClick={() => {
                                        this.attachmentMenuClick({ item: { id: file.fileId, action: 'download' } } as any, trItem);
                                        this.setState({ attachmentMenuOpen: null, attachmentMenuAnchor: null });
                                    }}
                                >
                                    <span className="k-menu-link">
                                        <span className="k-icon k-font-icon k-i-download"></span>
                                        {file.displayText} ({moment(file.lastChangedOn).format("YYYY-MM-DD HH:mm")})
                                    </span>
                                </li>
                            ))}
                        </>
                    )}
                </ul>
            </Popup>
        );
    }

    render() {
        return (
            <div data-component="splSrchRef" id="splSearchMainDiv" className={addPageViewClass(this.props.pageInf)} ref={this.containerRef}>
                <div id="splSearchHdrDiv" className={addPageViewClass(this.props.pageInf)} style={this.state.headerStyle}>
                    <div id="splSearchHdrDivP1">
                        {/* <DropDownList className="filterByList" data={filterByList} dataItemKey="key" textField="display" value={this.state.selectedFilterBy} onChange={this.selectedFilterByChange} /> */}
                        <Input className={"filterText " + addPageViewClass(this.props.pageInf)} placeholder="Enter Search Text (3 chars min)" value={this.state.searchStr} onChange={this.searchCriteriaChange} onKeyDown={this.searchTxtKeyDown} />
                        <Button className={"filterSearchBtn " + addPageViewClass(this.props.pageInf)} onClick={this.searchBtnClick} disabled={this.state.expandAllInProgress} ><span className="k-icon k-font-icon k-i-search srchIconsBtn" /></Button>

                        {this.props.pageInf.pageViewMode !== PageViewTypeEnum.Browser &&
                            <Button className={"filterSearchBtn " + addPageViewClass(this.props.pageInf)} onClick={this.cameraScanClick} title="Scan barcode using Camera" ><span className="k-icon k-font-icon k-i-qr-code-outline srchIconsBtn" /></Button>
                        }
                        {this.state.summaryResults.length > 0 &&
                            <div className="filterResultsLabel">Results</div>}
                        {this.state.summaryResults.length > 0 &&
                            <DropDownList className="filterResultsList" data={this.state.summaryResults} dataItemKey="key" textField="value" value={this.state.selectedSummaryResult} onChange={this.selectedSummaryResultChange} />
                        }
                    </div>
                    {this.state.expandAllInProgress &&
                        <div id="splSearchHdrExpandAllStatus" title="Expand All is running">
                            <span className="k-icon k-font-icon k-i-loading" />
                            <span>{this.state.expandAllCancelRequested ? 'Cancelling Expand All...' : 'Expanding all rows...'}</span>
                            <Button className="expandAllCancelBtn" onClick={this.cancelExpandAll} disabled={this.state.expandAllCancelRequested}>Cancel</Button>
                        </div>
                    }
                    <div id="splSearchHdrDivP3">
                        <Button className="refreshButton" onClick={this.refreshGrid} disabled={this.state.expandAllInProgress}><span className="k-icon k-font-icon k-i-reload" /></Button>
                    </div>
                </div>
                <div id="splSearchBdyDiv">
                    <Popup id="contextPopup"
                        offset={this._popupOffSet}
                        show={this.state.popupStatus !== ContextMenuStatus.Closed}
                        onOpen={this.popupOpen}
                    >
                        <div
                            ref={(el) => (this._popupDivRef = el)}
                            onFocus={this.onFocusHandler}
                            onBlur={this.onBlurHandler}
                            tabIndex={-1}>
                            {this.renderContextPopup()}
                        </div>
                    </Popup>
                    <TreeList
                        className="splSearchTreeList"
                        style={this.state.treeListStyle}
                        // tableProps={{ style: this.state.treeListTableStyle }}
                        data={this.state.searchResults}
                        dataItemKey="id"
                        subItemsField="childItems"
                        expandField="itemExpanded"
                        rowHeight={22}
                        scrollable="virtual"
                        onColumnResize={this.onColumnResize}
                        resizable={true}
                        noRecords={this.renderNoRecords()}
                        columns={this.state.treeListCols}
                        headerCellRender={this.renderHeaderCell}
                        rowRender={this.renderRow}
                    />
                    {/* Attachment menu popup */}
                    {this.state.attachmentMenuOpen && this.state.attachmentMenuAnchor && this.renderAttachmentPopup()}
                </div>
            </div>
        );
    }
}

export default connector(SplSearch);
